import { createIcon, type CreateIconType } from '../utils';

export const TrashIcon: CreateIconType = createIcon({
  displayName: 'TrashIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      d="M3 11.2656C3 11.5267 3.10536 11.7771 3.29289 11.9617C3.48043 12.1463 3.73478 12.25 4 12.25H10C10.2652 12.25 10.5196 12.1463 10.7071 11.9617C10.8946 11.7771 11 11.5267 11 11.2656V4.375H3V11.2656ZM8.66666 6.01563C8.66666 5.9286 8.70178 5.84514 8.7643 5.78361C8.82681 5.72207 8.91159 5.6875 9 5.6875C9.0884 5.6875 9.17319 5.72207 9.2357 5.78361C9.29821 5.84514 9.33333 5.9286 9.33333 6.01563V10.6094C9.33333 10.6964 9.29821 10.7799 9.2357 10.8414C9.17319 10.9029 9.0884 10.9375 9 10.9375C8.91159 10.9375 8.82681 10.9029 8.7643 10.8414C8.70178 10.7799 8.66666 10.6964 8.66666 10.6094V6.01563ZM6.66666 6.01563C6.66666 5.9286 6.70178 5.84514 6.7643 5.78361C6.82681 5.72207 6.91159 5.6875 7 5.6875C7.0884 5.6875 7.17319 5.72207 7.2357 5.78361C7.29821 5.84514 7.33333 5.9286 7.33333 6.01563V10.6094C7.33333 10.6964 7.29821 10.7799 7.2357 10.8414C7.17319 10.9029 7.0884 10.9375 7 10.9375C6.91159 10.9375 6.82681 10.9029 6.7643 10.8414C6.70178 10.7799 6.66666 10.6964 6.66666 10.6094V6.01563ZM4.66667 6.01563C4.66667 5.9286 4.70178 5.84514 4.7643 5.78361C4.82681 5.72207 4.91159 5.6875 5 5.6875C5.0884 5.6875 5.17319 5.72207 5.2357 5.78361C5.29821 5.84514 5.33333 5.9286 5.33333 6.01563V10.6094C5.33333 10.6964 5.29821 10.7799 5.2357 10.8414C5.17319 10.9029 5.0884 10.9375 5 10.9375C4.91159 10.9375 4.82681 10.9029 4.7643 10.8414C4.70178 10.7799 4.66667 10.6964 4.66667 10.6094V6.01563ZM11.3333 2.40625H8.83333L8.6375 2.02276C8.59601 1.94077 8.53211 1.8718 8.45298 1.82362C8.37385 1.77543 8.28263 1.74994 8.18958 1.75H5.80833C5.71549 1.74965 5.62443 1.77505 5.54558 1.82329C5.46673 1.87153 5.40328 1.94066 5.3625 2.02276L5.16666 2.40625H2.66667C2.57826 2.40625 2.49348 2.44082 2.43096 2.50236C2.36845 2.56389 2.33333 2.64735 2.33333 2.73438V3.39063C2.33333 3.47765 2.36845 3.56111 2.43096 3.62265C2.49348 3.68418 2.57826 3.71875 2.66667 3.71875H11.3333C11.4217 3.71875 11.5065 3.68418 11.569 3.62265C11.6315 3.56111 11.6667 3.47765 11.6667 3.39063V2.73438C11.6667 2.64735 11.6315 2.56389 11.569 2.50236C11.5065 2.44082 11.4217 2.40625 11.3333 2.40625V2.40625Z"
      fill="currentColor"
    />
  ),
});

export const ArrowLeft: CreateIconType = createIcon({
  displayName: 'ArrowLeft',
  viewBox: '0 0 14 14',
  path: (
    <path
      d="M6.7711 12.187C6.54329 12.4148 6.17394 12.4148 5.94614 12.187L1.22663 7.4675C0.998819 7.23969 0.998819 6.87034 1.22663 6.64254L5.94617 1.92299C6.17398 1.69518 6.54333 1.69518 6.77113 1.92299C6.99894 2.1508 6.99894 2.52014 6.77113 2.74795L3.04176 6.47732L12.3938 6.5149C12.716 6.51619 12.9761 6.77841 12.9748 7.10057C12.9735 7.42274 12.7113 7.68285 12.3891 7.68156L3.05308 7.64404L6.7711 11.3621C6.9989 11.5899 6.9989 11.9592 6.7711 12.187Z"
      fill="currentColor"
    />
  ),
});

export const SortIcon: CreateIconType = createIcon({
  displayName: 'SortIcon',
  viewBox: '0 0 14 14',
  path: (
    <>
      <path
        className="caret-ascending"
        d="M7.10919 11.6806L9.97334 8.44583C10.14 8.25761 10.0064 7.96081 9.75497 7.96081H4.24503C3.99364 7.96081 3.86001 8.25761 4.02666 8.44583L6.89081 11.6806C6.94885 11.7462 7.05115 11.7462 7.10919 11.6806Z"
        fill="currentColor"
      />
      <path
        className="caret-descending"
        d="M6.89082 2.31942L4.02666 5.55423C3.86001 5.74245 3.99364 6.03924 4.24503 6.03924L9.75497 6.03924C10.0064 6.03924 10.14 5.74245 9.97334 5.55423L7.10919 2.31942C7.05115 2.25388 6.94885 2.25388 6.89082 2.31942Z"
        fill="currentColor"
      />
    </>
  ),
});

export const WarningIcon: CreateIconType = createIcon({
  displayName: 'WarningIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.748 3.14413C12.9858 1.77324 11.0141 1.77325 10.252 3.14413L2.39389 17.2782C1.65274 18.6113 2.61665 20.25 4.1419 20.25H19.8581C21.3833 20.25 22.3472 18.6113 21.6061 17.2782L13.748 3.14413ZM12 6.25C11.3142 6.25 10.7715 6.83013 10.8171 7.51441L11.2173 13.5177C11.2448 13.9298 11.587 14.25 12 14.25C12.413 14.25 12.7552 13.9298 12.7827 13.5177L13.1829 7.51442C13.2285 6.83013 12.6858 6.25 12 6.25ZM12 15.75C11.3096 15.75 10.75 16.3096 10.75 17C10.75 17.6904 11.3096 18.25 12 18.25C12.6904 18.25 13.25 17.6904 13.25 17C13.25 16.3096 12.6904 15.75 12 15.75Z"
      fill="currentColor"
    />
  ),
});

export const AlertWarningIcon: CreateIconType = createIcon({
  displayName: 'AlertWarningIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.87498 14.875C9.87498 15.1734 9.99351 15.4595 10.2045 15.6705C10.4155 15.8815 10.7016 16 11 16C11.2983 16 11.5845 15.8815 11.7955 15.6705C12.0065 15.4595 12.125 15.1734 12.125 14.875C12.125 14.5766 12.0065 14.2905 11.7955 14.0795C11.5845 13.8685 11.2983 13.75 11 13.75C10.7016 13.75 10.4155 13.8685 10.2045 14.0795C9.99351 14.2905 9.87498 14.5766 9.87498 14.875ZM10.25 7.75V12.0625C10.25 12.1656 10.3344 12.25 10.4375 12.25H11.5625C11.6656 12.25 11.75 12.1656 11.75 12.0625V7.75C11.75 7.64687 11.6656 7.5625 11.5625 7.5625H10.4375C10.3344 7.5625 10.25 7.64687 10.25 7.75ZM21.3992 18.0625L11.6492 1.1875C11.5039 0.936719 11.2531 0.8125 11 0.8125C10.7469 0.8125 10.4937 0.936719 10.3508 1.1875L0.600765 18.0625C0.312484 18.5641 0.673421 19.1875 1.24998 19.1875H20.75C21.3265 19.1875 21.6875 18.5641 21.3992 18.0625ZM3.03592 17.4086L11 3.62266L18.964 17.4086H3.03592Z"
      fill="currentColor"
    />
  ),
});

export const ChevronDownIcon: CreateIconType = createIcon({
  displayName: 'ChevronDownIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.25 4.9L11.2 3.85L7 8.05L2.8 3.85L1.75 4.9L7 10.15L12.25 4.9Z"
      fill="currentColor"
    />
  ),
});

export const ChevronLeftIcon: CreateIconType = createIcon({
  displayName: 'ChevronLeftIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.1 12.25L10.15 11.2L5.95 7L10.15 2.8L9.1 1.75L3.85 7L9.1 12.25Z"
      fill="currentColor"
    />
  ),
});

export const ChevronRightIcon: CreateIconType = createIcon({
  displayName: 'ChevronRightIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.89999 1.75L3.84999 2.8L8.04999 7L3.84999 11.2L4.89999 12.25L10.15 7L4.89999 1.75Z"
      fill="currentColor"
    />
  ),
});

export const ChevronUpIcon: CreateIconType = createIcon({
  displayName: 'ChevronUpIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.75 9.1L2.8 10.15L7 5.95L11.2 10.15L12.25 9.1L7 3.85L1.75 9.1Z"
      fill="currentColor"
    />
  ),
});

export const DownloadDiskIcon: CreateIconType = createIcon({
  displayName: 'DownloadDiskIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      d="M11.0833 5.25H8.75V1.75H5.25V5.25H2.91667L7 9.91667L11.0833 5.25ZM2.33334 11.0833H11.6667V12.25H2.33334V11.0833Z"
      fill="currentColor"
    />
  ),
});

export const UploadDiskIcon: CreateIconType = createIcon({
  displayName: 'UploadDiskIcon',
  viewBox: '0 0 14 14',
  path: (
    <>
      <path
        d="M2.33334 11.0833H11.6667V12.25H2.33334V11.0833Z"
        fill="currentColor"
      />
      <path
        d="M11.0833 6.41666H8.75V9.91666H5.25V6.41666H2.91666L7 1.75L11.0833 6.41666Z"
        fill="currentColor"
      />
    </>
  ),
});

export const HourglassIcon: CreateIconType = createIcon({
  displayName: 'HourglassIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.03879 1.75262H10.9612V3.00262H10.5195C10.5123 4.36059 9.89206 5.64323 8.83107 6.4922L8.55685 6.71163V7.28932L8.84709 7.52375C9.89961 8.37386 10.5135 9.65215 10.5195 11.0044H10.9612V12.2544H3.03879V11.0044H3.48046C3.48598 9.64794 4.10315 8.36594 5.16082 7.51561L5.44315 7.28863V6.71163L5.16893 6.4922C4.10793 5.64323 3.48772 4.36059 3.48048 3.00262H3.03879V1.75262ZM9.51949 3.00262H4.4805C4.48772 4.05684 4.96988 5.0522 5.7937 5.7114L6.25554 6.08094C6.37412 6.17583 6.44315 6.31947 6.44315 6.47135V7.5282C6.44315 7.67967 6.37449 7.82297 6.25644 7.91788L5.78739 8.29497C4.96583 8.95549 4.48598 9.95088 4.48047 11.0044H5.18579V10.6916C5.18579 9.68961 5.99804 8.87736 7 8.87736C8.00197 8.87736 8.81422 9.68961 8.81422 10.6916V11.0044H9.51952C9.5135 9.95429 9.03622 8.96195 8.21876 8.30169L7.74268 7.91717C7.62516 7.82224 7.55685 7.67927 7.55685 7.5282V6.23107L8.2063 5.7114C9.03012 5.0522 9.51227 4.05684 9.51949 3.00262Z"
      fill="currentColor"
    />
  ),
});

export const OutlineCircleQuestionIcon: CreateIconType = createIcon({
  displayName: 'OutlineCircleQuestionIcon',
  viewBox: '0 0 14 14',
  path: (
    <>
      <path
        d="M7 1.75C4.10078 1.75 1.75 4.10078 1.75 7C1.75 9.89922 4.10078 12.25 7 12.25C9.89922 12.25 12.25 9.89922 12.25 7C12.25 4.10078 9.89922 1.75 7 1.75ZM7 11.3594C4.59297 11.3594 2.64063 9.40703 2.64063 7C2.64063 4.59297 4.59297 2.64063 7 2.64063C9.40703 2.64063 11.3594 4.59297 11.3594 7C11.3594 9.40703 9.40703 11.3594 7 11.3594Z"
        fill="currentColor"
      />
      <path
        d="M8.27148 4.77489C7.92968 4.47525 7.47851 4.31119 7 4.31119C6.52148 4.31119 6.07031 4.47639 5.72851 4.77489C5.37304 5.08593 5.17708 5.50406 5.17708 5.95181V6.0384C5.17708 6.08853 5.21809 6.12955 5.26822 6.12955H5.8151C5.86523 6.12955 5.90625 6.08853 5.90625 6.0384V5.95181C5.90625 5.44937 6.39729 5.04035 7 5.04035C7.6027 5.04035 8.09375 5.44937 8.09375 5.95181C8.09375 6.30614 7.84309 6.63085 7.45459 6.7801C7.21305 6.87239 7.00797 7.03417 6.861 7.24608C6.71175 7.46255 6.63427 7.72232 6.63427 7.9855V8.23046C6.63427 8.28059 6.67529 8.3216 6.72542 8.3216H7.27229C7.32242 8.3216 7.36344 8.28059 7.36344 8.23046V7.97183C7.36403 7.86123 7.39793 7.75337 7.46073 7.66232C7.52353 7.57127 7.61231 7.50126 7.71549 7.46142C8.38769 7.20279 8.82177 6.61034 8.82177 5.95181C8.82291 5.50406 8.62695 5.08593 8.27148 4.77489ZM6.54427 9.5065C6.54427 9.62737 6.59228 9.74328 6.67775 9.82875C6.76321 9.91422 6.87913 9.96223 7 9.96223C7.12086 9.96223 7.23678 9.91422 7.32224 9.82875C7.40771 9.74328 7.45572 9.62737 7.45572 9.5065C7.45572 9.38563 7.40771 9.26972 7.32224 9.18425C7.23678 9.09879 7.12086 9.05077 7 9.05077C6.87913 9.05077 6.76321 9.09879 6.67775 9.18425C6.59228 9.26972 6.54427 9.38563 6.54427 9.5065Z"
        fill="currentColor"
      />
    </>
  ),
});

export const KeyboardQuestionIcon: CreateIconType = createIcon({
  displayName: 'KeyboardQuestionIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M15.4375 5.25C15.6133 5.25 15.7853 5.2665 15.952 5.29804C14.9776 5.59236 14.093 6.09334 13.349 6.75H2.9375C2.24714 6.75 1.6875 7.30964 1.6875 8V16C1.6875 16.6904 2.24714 17.25 2.9375 17.25H13.349C14.093 17.9067 14.9776 18.4076 15.952 18.702C15.7853 18.7335 15.6133 18.75 15.4375 18.75H2.9375C1.41872 18.75 0.1875 17.5188 0.1875 16V8C0.1875 6.48122 1.41872 5.25 2.9375 5.25H15.4375Z"
        fill="currentColor"
      />
      <path
        d="M11.3625 8.0625H12.1908C11.8022 8.63264 11.4957 9.26317 11.2881 9.93709C11.23 9.93601 11.1942 9.93198 11.1649 9.91706C11.1296 9.89909 11.1009 9.8704 11.0829 9.83512C11.0625 9.79501 11.0625 9.74251 11.0625 9.6375V8.3625C11.0625 8.25749 11.0625 8.20499 11.0829 8.16488C11.1009 8.1296 11.1296 8.10091 11.1649 8.08294C11.205 8.0625 11.2575 8.0625 11.3625 8.0625Z"
        fill="currentColor"
      />
      <path
        d="M5.7375 14.0625H11.288C11.4955 14.7366 11.8021 15.3672 12.1908 15.9375H5.7375C5.63249 15.9375 5.57999 15.9375 5.53988 15.9171C5.5046 15.8991 5.47591 15.8704 5.45794 15.8351C5.4375 15.795 5.4375 15.7425 5.4375 15.6375V14.3625C5.4375 14.2575 5.4375 14.205 5.45794 14.1649C5.47591 14.1296 5.5046 14.1009 5.53988 14.0829C5.57999 14.0625 5.63249 14.0625 5.7375 14.0625Z"
        fill="currentColor"
      />
      <path
        d="M2.625 8.3625C2.625 8.25749 2.625 8.20499 2.64544 8.16488C2.66341 8.1296 2.6921 8.10091 2.72738 8.08294C2.76749 8.0625 2.81999 8.0625 2.925 8.0625H4.2C4.30501 8.0625 4.35751 8.0625 4.39762 8.08294C4.4329 8.10091 4.46159 8.1296 4.47956 8.16488C4.5 8.20499 4.5 8.25749 4.5 8.3625V9.6375C4.5 9.74251 4.5 9.79501 4.47956 9.83512C4.46159 9.8704 4.4329 9.89909 4.39762 9.91706C4.35751 9.9375 4.30501 9.9375 4.2 9.9375H2.925C2.81999 9.9375 2.76749 9.9375 2.72738 9.91706C2.6921 9.89909 2.66341 9.8704 2.64544 9.83512C2.625 9.79501 2.625 9.74251 2.625 9.6375V8.3625Z"
        fill="currentColor"
      />
      <path
        d="M5.4375 8.3625C5.4375 8.25749 5.4375 8.20499 5.45794 8.16488C5.47591 8.1296 5.5046 8.10091 5.53988 8.08294C5.57999 8.0625 5.63249 8.0625 5.7375 8.0625H7.0125C7.11751 8.0625 7.17001 8.0625 7.21012 8.08294C7.2454 8.10091 7.27409 8.1296 7.29206 8.16488C7.3125 8.20499 7.3125 8.25749 7.3125 8.3625V9.6375C7.3125 9.74251 7.3125 9.79501 7.29206 9.83512C7.27409 9.8704 7.2454 9.89909 7.21012 9.91706C7.17001 9.9375 7.11751 9.9375 7.0125 9.9375H5.7375C5.63249 9.9375 5.57999 9.9375 5.53988 9.91706C5.5046 9.89909 5.47591 9.8704 5.45794 9.83512C5.4375 9.79501 5.4375 9.74251 5.4375 9.6375V8.3625Z"
        fill="currentColor"
      />
      <path
        d="M8.27044 8.16488C8.25 8.20499 8.25 8.25749 8.25 8.3625V9.6375C8.25 9.74251 8.25 9.79501 8.27044 9.83512C8.28841 9.8704 8.3171 9.89909 8.35238 9.91706C8.39249 9.9375 8.44499 9.9375 8.55 9.9375H9.825C9.93001 9.9375 9.98251 9.9375 10.0226 9.91706C10.0579 9.89909 10.0866 9.8704 10.1046 9.83512C10.125 9.79501 10.125 9.74251 10.125 9.6375V8.3625C10.125 8.25749 10.125 8.20499 10.1046 8.16488C10.0866 8.1296 10.0579 8.10091 10.0226 8.08294C9.98251 8.0625 9.93001 8.0625 9.825 8.0625H8.55C8.44499 8.0625 8.39249 8.0625 8.35238 8.08294C8.3171 8.10091 8.28841 8.1296 8.27044 8.16488Z"
        fill="currentColor"
      />
      <path
        d="M2.625 11.3625C2.625 11.2575 2.625 11.205 2.64544 11.1649C2.66341 11.1296 2.6921 11.1009 2.72738 11.0829C2.76749 11.0625 2.81999 11.0625 2.925 11.0625H4.2C4.30501 11.0625 4.35751 11.0625 4.39762 11.0829C4.4329 11.1009 4.46159 11.1296 4.47956 11.1649C4.5 11.205 4.5 11.2575 4.5 11.3625V12.6375C4.5 12.7425 4.5 12.795 4.47956 12.8351C4.46159 12.8704 4.4329 12.8991 4.39762 12.9171C4.35751 12.9375 4.30501 12.9375 4.2 12.9375H2.925C2.81999 12.9375 2.76749 12.9375 2.72738 12.9171C2.6921 12.8991 2.66341 12.8704 2.64544 12.8351C2.625 12.795 2.625 12.7425 2.625 12.6375V11.3625Z"
        fill="currentColor"
      />
      <path
        d="M5.45794 11.1649C5.4375 11.205 5.4375 11.2575 5.4375 11.3625V12.6375C5.4375 12.7425 5.4375 12.795 5.45794 12.8351C5.47591 12.8704 5.5046 12.8991 5.53988 12.9171C5.57999 12.9375 5.63249 12.9375 5.7375 12.9375H7.0125C7.11751 12.9375 7.17001 12.9375 7.21012 12.9171C7.2454 12.8991 7.27409 12.8704 7.29206 12.8351C7.3125 12.795 7.3125 12.7425 7.3125 12.6375V11.3625C7.3125 11.2575 7.3125 11.205 7.29206 11.1649C7.27409 11.1296 7.2454 11.1009 7.21012 11.0829C7.17001 11.0625 7.11751 11.0625 7.0125 11.0625H5.7375C5.63249 11.0625 5.57999 11.0625 5.53988 11.0829C5.5046 11.1009 5.47591 11.1296 5.45794 11.1649Z"
        fill="currentColor"
      />
      <path
        d="M8.25 11.3625C8.25 11.2575 8.25 11.205 8.27044 11.1649C8.28841 11.1296 8.3171 11.1009 8.35238 11.0829C8.39249 11.0625 8.44499 11.0625 8.55 11.0625H9.825C9.93001 11.0625 9.98251 11.0625 10.0226 11.0829C10.0579 11.1009 10.0866 11.1296 10.1046 11.1649C10.125 11.205 10.125 11.2575 10.125 11.3625V12.6375C10.125 12.7425 10.125 12.795 10.1046 12.8351C10.0866 12.8704 10.0579 12.8991 10.0226 12.9171C9.98251 12.9375 9.93001 12.9375 9.825 12.9375H8.55C8.44499 12.9375 8.39249 12.9375 8.35238 12.9171C8.3171 12.8991 8.28841 12.8704 8.27044 12.8351C8.25 12.795 8.25 12.7425 8.25 12.6375V11.3625Z"
        fill="currentColor"
      />
      <path
        d="M2.64544 14.1649C2.625 14.205 2.625 14.2575 2.625 14.3625V15.6375C2.625 15.7425 2.625 15.795 2.64544 15.8351C2.66341 15.8704 2.6921 15.8991 2.72738 15.9171C2.76749 15.9375 2.81999 15.9375 2.925 15.9375H4.2C4.30501 15.9375 4.35751 15.9375 4.39762 15.9171C4.4329 15.8991 4.46159 15.8704 4.47956 15.8351C4.5 15.795 4.5 15.7425 4.5 15.6375V14.3625C4.5 14.2575 4.5 14.205 4.47956 14.1649C4.46159 14.1296 4.4329 14.1009 4.39762 14.0829C4.35751 14.0625 4.30501 14.0625 4.2 14.0625H2.925C2.81999 14.0625 2.76749 14.0625 2.72738 14.0829C2.6921 14.1009 2.66341 14.1296 2.64544 14.1649Z"
        fill="currentColor"
      />
      <path
        d="M17.9792 9.82986C18.6102 9.82986 18.8666 10.2145 18.8666 10.408C18.8666 10.6186 18.8164 10.7035 18.7775 10.7533C18.7177 10.8298 18.625 10.8987 18.4198 11.0302C17.9665 11.3206 17.3542 11.8291 17.3542 12.8142V13.1667C17.3542 13.5118 17.634 13.7917 17.9792 13.7917C18.3244 13.7917 18.6042 13.5118 18.6042 13.1667V12.8142C18.6042 12.6163 18.6583 12.4926 18.7275 12.3975C18.8061 12.2896 18.9249 12.1911 19.0941 12.0827L19.1052 12.0756C19.2887 11.9581 19.5566 11.7866 19.7627 11.5226C19.9939 11.2266 20.1166 10.8619 20.1166 10.408C20.1166 9.27257 19.0187 8.57986 17.9792 8.57986C16.9397 8.57986 15.8419 9.27257 15.8419 10.408C15.8419 10.7532 16.1217 11.033 16.4669 11.033C16.812 11.033 17.0919 10.7532 17.0919 10.408C17.0919 10.2145 17.3482 9.82986 17.9792 9.82986Z"
        fill="currentColor"
      />
      <path
        d="M17.9792 15.1111C17.657 15.1111 17.3959 14.8499 17.3959 14.5278C17.3959 14.2056 17.657 13.9444 17.9792 13.9444C18.3014 13.9444 18.5625 14.2056 18.5625 14.5278C18.5625 14.8499 18.3014 15.1111 17.9792 15.1111Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9792 17.8333C21.2009 17.8333 23.8125 15.2217 23.8125 12C23.8125 8.77834 21.2009 6.16667 17.9792 6.16667C14.7575 6.16667 12.1459 8.77834 12.1459 12C12.1459 15.2217 14.7575 17.8333 17.9792 17.8333ZM17.9792 16.5833C20.5105 16.5833 22.5625 14.5313 22.5625 12C22.5625 9.46869 20.5105 7.41667 17.9792 7.41667C15.4479 7.41667 13.3959 9.46869 13.3959 12C13.3959 14.5313 15.4479 16.5833 17.9792 16.5833Z"
        fill="currentColor"
      />
    </>
  ),
});

export const ArrowBarLeft: CreateIconType = createIcon({
  displayName: 'ArrowBarLeft',
  viewBox: '0 0 14 14',
  path: (
    <>
      <path d="M12.25 1.75H11.0833V12.25H12.25V1.75Z" fill="currentColor" />
      <path
        d="M9.91667 7.58333H3.983L5.19983 8.80017L4.375 9.625L1.75 7L4.375 4.375L5.19983 5.19983L3.983 6.41667H9.91667V7.58333Z"
        fill="currentColor"
      />
    </>
  ),
});

export const ArrowBarRight: CreateIconType = createIcon({
  displayName: 'ArrowBarRight',
  viewBox: '0 0 14 14',
  path: (
    <>
      <path d="M1.75 1.75H2.91666V12.25H1.75V1.75Z" fill="currentColor" />
      <path
        d="M4.08333 7.58333H10.017L8.80017 8.80017L9.625 9.625L12.25 7L9.625 4.375L8.80017 5.19983L10.017 6.41667H4.08333V7.58333Z"
        fill="currentColor"
      />
    </>
  ),
});

export const AddIcon: CreateIconType = createIcon({
  displayName: 'AddIcon',
  viewBox: '0 0 14 14',
  path: (
    <>
      <path
        d="M6.53948 1.75H7.46053C7.5424 1.75 7.58334 1.78889 7.58334 1.86667V12.1333C7.58334 12.2111 7.5424 12.25 7.46053 12.25H6.53948C6.45761 12.25 6.41667 12.2111 6.41667 12.1333V1.86667C6.41667 1.78889 6.45761 1.75 6.53948 1.75Z"
        fill="currentColor"
      />
      <path
        d="M1.87209 6.41666H12.1279C12.2093 6.41666 12.25 6.4576 12.25 6.53947V7.46052C12.25 7.54239 12.2093 7.58333 12.1279 7.58333H1.87209C1.7907 7.58333 1.75 7.54239 1.75 7.46052V6.53947C1.75 6.4576 1.7907 6.41666 1.87209 6.41666Z"
        fill="currentColor"
      />
    </>
  ),
});

export const CloseIcon: CreateIconType = createIcon({
  displayName: 'CloseIcon',
  viewBox: '0 0 14 14',
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2867 12.25L1.75 2.71335L2.71335 1.75L12.25 11.2867L11.2867 12.25Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.25 2.71335L2.71335 12.25L1.75 11.2867L11.2867 1.75L12.25 2.71335Z"
        fill="currentColor"
      />
    </>
  ),
});

export const SwapIcon: CreateIconType = createIcon({
  displayName: 'SwapIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.75 16C2.75 16.4142 3.08579 16.75 3.5 16.75H16V18.1315C16 18.9302 16.8901 19.4066 17.5547 18.9635L20.7519 16.832C21.3457 16.4362 21.3457 15.5638 20.7519 15.1679L17.5547 13.0365C16.8901 12.5934 16 13.0698 16 13.8685V15.25H3.5C3.08579 15.25 2.75 15.5858 2.75 16ZM3.24808 8.83206L6.4453 10.9635C7.10986 11.4066 8 10.9302 8 10.1315V8.75L20.5 8.75C20.9142 8.75 21.25 8.41422 21.25 8C21.25 7.58579 20.9142 7.25 20.5 7.25L8 7.25V5.86852C8 5.06983 7.10986 4.59344 6.4453 5.03647L3.24808 7.16796C2.65434 7.56378 2.65434 8.43623 3.24808 8.83206Z"
      fill="currentColor"
    />
  ),
});

export const GearIcon: CreateIconType = createIcon({
  displayName: 'GearIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.25 7.63113V6.3412H10.8862C10.7883 5.75601 10.5588 5.20071 10.2148 4.71725L11.1787 3.75342L10.2471 2.82187L9.28322 3.7857C8.79973 3.44153 8.24444 3.21154 7.65917 3.11306V1.75H6.34148V3.11306C5.75613 3.21123 5.20077 3.44124 4.71743 3.7857L3.75355 2.82187L2.84105 3.73366L3.8023 4.69485C3.44904 5.18334 3.21321 5.74673 3.11315 6.3412H1.75V7.63113H3.1092C3.20437 8.22637 3.4357 8.79159 3.78517 9.28275L2.82128 10.2466L3.75289 11.1781L4.71678 10.2143C5.19114 10.5523 5.7426 10.7855 6.34083 10.8869V12.25H7.65851V10.8869C8.25299 10.7868 8.81638 10.551 9.30497 10.1978L10.2656 11.1584L11.1781 10.2466L10.2142 9.28275C10.5635 8.79151 10.7948 8.22632 10.8901 7.63113H12.25V7.63113ZM7.01351 9.01001C6.48375 8.99651 5.98023 8.7766 5.61031 8.39717C5.2404 8.01774 5.03337 7.50881 5.03337 6.97892C5.03337 6.44902 5.2404 5.9401 5.61031 5.56066C5.98023 5.18123 6.48375 4.96132 7.01351 4.94783C7.54326 4.96132 8.04678 5.18123 8.4167 5.56066C8.78661 5.9401 8.99364 6.44902 8.99364 6.97892C8.99364 7.50881 8.78661 8.01774 8.4167 8.39717C8.04678 8.7766 7.54326 8.99651 7.01351 9.01001Z"
      fill="currentColor"
    />
  ),
});

export const SendIcon: CreateIconType = createIcon({
  displayName: 'SendIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      d="M1.75528 11.6667L12.8333 6.99999L1.75528 2.33333L1.75 5.96296L9.66667 6.99999L1.75 8.03703L1.75528 11.6667Z"
      fill="currentColor"
    />
  ),
});

export const UndoIcon: CreateIconType = createIcon({
  displayName: 'UndoIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      d="M12.25 10.5L11.5402 9.88921C10.9728 9.4013 10.4466 9.02467 9.72091 8.77264C9.04927 8.53943 8.20649 8.41788 7.0891 8.39524V10.3478L1.75 6.92391L7.0891 3.5V5.46323C8.92862 5.5203 10.2992 5.97834 11.1669 6.82804C11.8855 7.53261 12.25 8.50633 12.25 9.72505V10.5Z"
      fill="currentColor"
    />
  ),
});

export const RedoIcon: CreateIconType = createIcon({
  displayName: 'RedoIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      d="M1.75 9.72505C1.75 8.50633 2.11447 7.53261 2.83306 6.8288C3.70083 5.9791 5.07138 5.52068 6.9109 5.46399V3.5L12.25 6.92391L6.9109 10.3478V8.39524C5.79401 8.41788 4.95073 8.53943 4.27909 8.77264C3.55343 9.02467 3.02716 9.4013 2.45976 9.88921L1.75 10.5V9.72505Z"
      fill="currentColor"
    />
  ),
});

export const EllipsisVerticalIcon: CreateIconType = createIcon({
  displayName: 'EllipsisVerticalIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.16667 3.0625C8.16667 3.4106 8.02839 3.74444 7.78225 3.99058C7.53611 4.23672 7.20227 4.375 6.85417 4.375C6.50607 4.375 6.17224 4.23672 5.92609 3.99058C5.67995 3.74444 5.54167 3.4106 5.54167 3.0625C5.54167 2.7144 5.67995 2.38056 5.92609 2.13442C6.17224 1.88828 6.50607 1.75 6.85417 1.75C7.20227 1.75 7.53611 1.88828 7.78225 2.13442C8.02839 2.38056 8.16667 2.7144 8.16667 3.0625ZM8.16667 10.9375C8.16667 11.2856 8.02839 11.6194 7.78225 11.8656C7.53611 12.1117 7.20227 12.25 6.85417 12.25C6.50607 12.25 6.17224 12.1117 5.92609 11.8656C5.67995 11.6194 5.54167 11.2856 5.54167 10.9375C5.54167 10.5894 5.67995 10.2556 5.92609 10.0094C6.17224 9.76328 6.50607 9.625 6.85417 9.625C7.20227 9.625 7.53611 9.76328 7.78225 10.0094C8.02839 10.2556 8.16667 10.5894 8.16667 10.9375ZM8.16667 7C8.16667 7.3481 8.02839 7.68194 7.78225 7.92808C7.53611 8.17422 7.20227 8.3125 6.85417 8.3125C6.50607 8.3125 6.17224 8.17422 5.92609 7.92808C5.67995 7.68194 5.54167 7.3481 5.54167 7C5.54167 6.6519 5.67995 6.31806 5.92609 6.07192C6.17224 5.82578 6.50607 5.6875 6.85417 5.6875C7.20227 5.6875 7.53611 5.82578 7.78225 6.07192C8.02839 6.31806 8.16667 6.6519 8.16667 7Z"
      fill="currentColor"
    />
  ),
});

export const EllipsisHorizontalIcon: CreateIconType = createIcon({
  displayName: 'EllipsisHorizontalIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.33 14C6.43457 14 7.33 13.1046 7.33 12C7.33 10.8954 6.43457 10 5.33 10C4.22543 10 3.33 10.8954 3.33 12C3.33 13.1046 4.22543 14 5.33 14ZM13.9967 12C13.9967 13.1046 13.1012 14 11.9967 14C10.8921 14 9.99667 13.1046 9.99667 12C9.99667 10.8954 10.8921 10 11.9967 10C13.1012 10 13.9967 10.8954 13.9967 12ZM20.6633 12C20.6633 13.1046 19.7679 14 18.6633 14C17.5588 14 16.6633 13.1046 16.6633 12C16.6633 10.8954 17.5588 10 18.6633 10C19.7679 10 20.6633 10.8954 20.6633 12Z"
      fill="currentColor"
    />
  ),
});

export const PencilBarIcon: CreateIconType = createIcon({
  displayName: 'PencilBarIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      d="M11.83 11.2525H2.17C1.93769 11.2525 1.75 11.4402 1.75 11.6725V12.145C1.75 12.2027 1.79725 12.25 1.855 12.25H12.145C12.2027 12.25 12.25 12.2027 12.25 12.145V11.6725C12.25 11.4402 12.0623 11.2525 11.83 11.2525ZM3.66231 10.15C3.68856 10.15 3.71481 10.1474 3.74106 10.1434L5.94869 9.75625C5.97494 9.751 5.99988 9.73919 6.01825 9.7195L11.5819 4.15581C11.5941 4.14367 11.6038 4.12925 11.6103 4.11337C11.6169 4.09749 11.6203 4.08047 11.6203 4.06328C11.6203 4.04609 11.6169 4.02907 11.6103 4.01319C11.6038 3.99732 11.5941 3.98289 11.5819 3.97075L9.40056 1.78806C9.37563 1.76313 9.34281 1.75 9.30737 1.75C9.27194 1.75 9.23912 1.76313 9.21419 1.78806L3.6505 7.35175C3.63081 7.37144 3.619 7.39506 3.61375 7.42131L3.22656 9.62894C3.21379 9.69925 3.21836 9.77161 3.23985 9.83977C3.26135 9.90792 3.29914 9.9698 3.34994 10.0201C3.43656 10.1041 3.5455 10.15 3.66231 10.15V10.15Z"
      fill="currentColor"
    />
  ),
});

export const HamburgerMenuIcon: CreateIconType = createIcon({
  displayName: 'HamburgerMenuIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      d="M1.75 7.77778H12.25V6.22222H1.75V7.77778ZM1.75 11.6667H12.25V10.1111H1.75V11.6667ZM1.75 2.33333V3.88889H12.25V2.33333H1.75Z"
      fill="currentColor"
    />
  ),
});

export const OutlineSquarePlusIcon: CreateIconType = createIcon({
  displayName: 'OutlineSquarePlusIcon',
  viewBox: '0 0 14 14',
  path: (
    <>
      <path
        d="M4.48438 7.4375H6.5625V9.51562C6.5625 9.57578 6.61172 9.625 6.67188 9.625H7.32812C7.38828 9.625 7.4375 9.57578 7.4375 9.51562V7.4375H9.51562C9.57578 7.4375 9.625 7.38828 9.625 7.32812V6.67188C9.625 6.61172 9.57578 6.5625 9.51562 6.5625H7.4375V4.48438C7.4375 4.42422 7.38828 4.375 7.32812 4.375H6.67188C6.61172 4.375 6.5625 4.42422 6.5625 4.48438V6.5625H4.48438C4.42422 6.5625 4.375 6.61172 4.375 6.67188V7.32812C4.375 7.38828 4.42422 7.4375 4.48438 7.4375Z"
        fill="currentColor"
      />
      <path
        d="M11.83 1.75H2.17C1.93769 1.75 1.75 1.93769 1.75 2.17V11.83C1.75 12.0623 1.93769 12.25 2.17 12.25H11.83C12.0623 12.25 12.25 12.0623 12.25 11.83V2.17C12.25 1.93769 12.0623 1.75 11.83 1.75ZM11.305 11.305H2.695V2.695H11.305V11.305Z"
        fill="currentColor"
      />
    </>
  ),
});

export const OutlineSquareMinusIcon: CreateIconType = createIcon({
  displayName: 'OutlineSquareMinusIcon',
  viewBox: '0 0 14 14',
  path: (
    <>
      <path
        d="M4.48437 7.58333H9.51562C9.57578 7.58333 9.625 7.51771 9.625 7.4375V6.5625C9.625 6.48229 9.57578 6.41667 9.51562 6.41667H4.48437C4.42422 6.41667 4.375 6.48229 4.375 6.5625V7.4375C4.375 7.51771 4.42422 7.58333 4.48437 7.58333Z"
        fill="currentColor"
      />
      <path
        d="M11.83 1.75H2.17C1.93769 1.75 1.75 1.93769 1.75 2.17V11.83C1.75 12.0623 1.93769 12.25 2.17 12.25H11.83C12.0623 12.25 12.25 12.0623 12.25 11.83V2.17C12.25 1.93769 12.0623 1.75 11.83 1.75ZM11.305 11.305H2.695V2.695H11.305V11.305Z"
        fill="currentColor"
      />
    </>
  ),
});

export const OutlineCircleCheckmark: CreateIconType = createIcon({
  displayName: 'OutlineCircleCheckmark',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M16.7744 9.33958C17.0171 9.00397 16.9419 8.5351 16.6063 8.29232C16.2706 8.04955 15.8018 8.12481 15.559 8.46042L11.1586 14.5435C11.059 14.6813 10.8539 14.6816 10.7539 14.5441L9.27315 12.5088C9.02947 12.1738 8.56039 12.0998 8.22544 12.3435C7.89049 12.5872 7.8165 13.0563 8.06018 13.3912L9.5409 15.4265C10.241 16.3888 11.6765 16.3868 12.3739 15.4227L16.7744 9.33958Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12Z"
        fill="currentColor"
      />
    </>
  ),
});

export const OutlineCircleExclamation: CreateIconType = createIcon({
  displayName: 'OutlineCircleExclamation',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        fill="currentColor"
      />
      <path
        d="M12 6.25C11.3142 6.25 10.7715 6.83013 10.8171 7.51442L11.2173 13.5177C11.2448 13.9298 11.587 14.25 12 14.25C12.413 14.25 12.7552 13.9298 12.7827 13.5177L13.1829 7.51442C13.2285 6.83013 12.6858 6.25 12 6.25Z"
        fill="currentColor"
      />
      <path
        d="M12 15.75C11.3096 15.75 10.75 16.3096 10.75 17C10.75 17.6904 11.3096 18.25 12 18.25C12.6904 18.25 13.25 17.6904 13.25 17C13.25 16.3096 12.6904 15.75 12 15.75Z"
        fill="currentColor"
      />
    </>
  ),
});

export const SearchIcon: CreateIconType = createIcon({
  displayName: 'SearchIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      d="M12.2185 11.4953L8.80991 8.08672C9.33884 7.40291 9.62497 6.56685 9.62497 5.68748C9.62497 4.63486 9.21415 3.64787 8.47128 2.90368C7.72841 2.1595 6.73879 1.75 5.68748 1.75C4.63617 1.75 3.64655 2.16081 2.90368 2.90368C2.1595 3.64655 1.75 4.63486 1.75 5.68748C1.75 6.73879 2.16081 7.72841 2.90368 8.47128C3.64655 9.21547 4.63486 9.62497 5.68748 9.62497C6.56685 9.62497 7.4016 9.33884 8.08541 8.81122L11.494 12.2185C11.504 12.2285 11.5158 12.2364 11.5289 12.2418C11.5419 12.2472 11.5559 12.25 11.5701 12.25C11.5842 12.25 11.5982 12.2472 11.6113 12.2418C11.6243 12.2364 11.6362 12.2285 11.6462 12.2185L12.2185 11.6475C12.2285 11.6375 12.2364 11.6257 12.2418 11.6126C12.2472 11.5995 12.25 11.5855 12.25 11.5714C12.25 11.5573 12.2472 11.5433 12.2418 11.5302C12.2364 11.5171 12.2285 11.5053 12.2185 11.4953V11.4953ZM7.76647 7.76647C7.20998 8.32166 6.47235 8.62747 5.68748 8.62747C4.90261 8.62747 4.16499 8.32166 3.60849 7.76647C3.05331 7.20998 2.7475 6.47235 2.7475 5.68748C2.7475 4.90261 3.05331 4.16368 3.60849 3.60849C4.16499 3.05331 4.90261 2.7475 5.68748 2.7475C6.47235 2.7475 7.21129 3.05199 7.76647 3.60849C8.32166 4.16499 8.62747 4.90261 8.62747 5.68748C8.62747 6.47235 8.32166 7.21129 7.76647 7.76647Z"
      fill="currentColor"
    />
  ),
});

export const ExpandIcon: CreateIconType = createIcon({
  displayName: 'ExpandIcon',
  viewBox: '0 0 14 14',
  path: (
    <>
      <path
        d="M9.625 3.39062L7 6.01562L7.98438 7L10.6094 4.375L12.25 5.6875V1.75H7.98438L9.625 3.39062Z"
        fill="currentColor"
      />
      <path
        d="M4.375 10.6094L7 7.98438L6.01563 7L3.39063 9.625L1.75 8.3125L1.75 12.25L6.01562 12.25L4.375 10.6094Z"
        fill="currentColor"
      />
    </>
  ),
});

export const CollapseIcon: CreateIconType = createIcon({
  displayName: 'CollapseIcon',
  viewBox: '0 0 14 14',
  path: (
    <>
      <path
        d="M10.2083 4.77603L12.8333 2.15103L11.849 1.16666L9.22396 3.79166L7.58333 2.47916L7.58333 6.41666L11.849 6.41666L10.2083 4.77603Z"
        fill="currentColor"
      />
      <path
        d="M3.79167 9.22397L1.16667 11.849L2.15104 12.8333L4.77604 10.2083L6.41667 11.5208L6.41667 7.58334L2.15104 7.58334L3.79167 9.22397Z"
        fill="currentColor"
      />
    </>
  ),
});

export const CheckmarkIcon: CreateIconType = createIcon({
  displayName: 'CheckmarkIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.0625 5.63888L1.75 6.99999L5.6875 11.0833L12.25 4.27777L10.9375 2.91666L5.6875 8.3611L3.0625 5.63888Z"
      fill="currentColor"
    />
  ),
});

export const ScrollNavigationIcon: CreateIconType = createIcon({
  displayName: 'ScrollNavigationIcon',
  viewBox: '0 0 14 14',
  path: (
    <>
      <path
        d="M9.33335 4.08333H7H4.66671L7 1.75L9.33335 4.08333Z"
        fill="currentColor"
      />
      <path
        d="M4.66671 9.91667H7.00006H9.33335L7.00006 12.25L4.66671 9.91667Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.00004 5.83334C7.30946 5.83334 7.60621 5.95625 7.825 6.17504C8.04379 6.39384 8.16671 6.69058 8.16671 7C8.16671 7.30942 8.04379 7.60617 7.825 7.82496C7.60621 8.04375 7.30946 8.16667 7.00004 8.16667C6.69062 8.16667 6.39388 8.04375 6.17508 7.82496C5.95629 7.60617 5.83337 7.30942 5.83337 7C5.83337 6.69058 5.95629 6.39384 6.17508 6.17504C6.39388 5.95625 6.69062 5.83334 7.00004 5.83334Z"
        fill="currentColor"
      />
    </>
  ),
});

export const DragHandleIcon: CreateIconType = createIcon({
  displayName: 'DragHandleIcon',
  viewBox: '0 0 21 21',
  path: (
    <>
      <circle cx="8.08633" cy="6.02541" r="1.6" fill="currentColor" />
      <circle cx="13.2865" cy="6.02541" r="1.6" fill="currentColor" />
      <circle cx="8.08633" cy="10.7254" r="1.6" fill="currentColor" />
      <circle cx="13.2865" cy="10.7254" r="1.6" fill="currentColor" />
      <circle cx="8.08633" cy="15.4253" r="1.6" fill="currentColor" />
      <circle cx="13.2865" cy="15.4253" r="1.6" fill="currentColor" />
    </>
  ),
});

export const ReorderIcon: CreateIconType = createIcon({
  displayName: 'ReorderIcon',
  viewBox: '0 0 14 14',
  path: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.75"
        y="3.5"
        width="10.5"
        height="1.16667"
        fill="currentColor"
      />
      <rect
        x="1.75"
        y="6.41667"
        width="10.5"
        height="1.16667"
        fill="currentColor"
      />
      <rect
        x="1.75"
        y="9.33333"
        width="10.5"
        height="1.16667"
        fill="currentColor"
      />
    </svg>
  ),
});

export const CaretDownIcon: CreateIconType = createIcon({
  displayName: 'CaretDownIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      d="M11.8978 3.79166H2.10219C1.80838 3.79166 1.64432 4.10645 1.82628 4.32137L6.72409 10.0846C6.86428 10.2496 7.13423 10.2496 7.27591 10.0846L12.1737 4.32137C12.3557 4.10645 12.1916 3.79166 11.8978 3.79166Z"
      fill="currentColor"
    />
  ),
});

export const SortAscendingIcon: CreateIconType = createIcon({
  displayName: 'SortAscendingIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      d="M11.6609 5.88438L10.372 1.84274C10.3636 1.81569 10.3468 1.79207 10.324 1.77537C10.3012 1.75867 10.2736 1.74977 10.2454 1.75H9.14425C9.08592 1.75 9.03613 1.7871 9.01764 1.84274L7.71879 5.88438C7.71452 5.89722 7.71167 5.91148 7.71167 5.92575C7.71167 5.99851 7.77142 6.05843 7.84398 6.05843H8.64633C8.70608 6.05843 8.7573 6.01848 8.77437 5.96142L9.02333 5.08261H10.2895L10.5356 5.95999C10.5512 6.01705 10.6039 6.057 10.6636 6.057H11.5342C11.5485 6.057 11.5613 6.05557 11.5741 6.05129C11.6082 6.03988 11.6353 6.01705 11.6523 5.98567C11.668 5.95428 11.6708 5.91862 11.6609 5.88438V5.88438ZM9.15278 4.33934L9.6194 2.67161H9.70903L10.1657 4.33934H9.15278V4.33934ZM11.1942 11.3712H9.35053V11.3655L11.2369 8.67059C11.2526 8.64776 11.2611 8.62208 11.2611 8.59355V8.07425C11.2611 8.0015 11.2014 7.94158 11.1288 7.94158H8.22666C8.15411 7.94158 8.09436 8.0015 8.09436 8.07425V8.6877C8.09436 8.76046 8.15411 8.82038 8.22666 8.82038H9.97079V8.82609L8.07729 11.521C8.06148 11.5435 8.05303 11.5705 8.0531 11.598V12.1173C8.0531 12.1901 8.11285 12.25 8.18541 12.25H11.1928C11.2654 12.25 11.3251 12.1901 11.3251 12.1173V11.5039C11.3253 11.4865 11.3221 11.4693 11.3156 11.4532C11.3091 11.4371 11.2995 11.4225 11.2873 11.4101C11.2751 11.3978 11.2606 11.388 11.2447 11.3813C11.2287 11.3746 11.2115 11.3712 11.1942 11.3712V11.3712ZM5.63466 9.7106H4.55347V2.14946C4.55347 2.08669 4.50225 2.03533 4.43966 2.03533H3.64299C3.5804 2.03533 3.52918 2.08669 3.52918 2.14946V9.7106H2.44799C2.35268 9.7106 2.29862 9.82188 2.35837 9.89606L3.9517 11.9204C3.96235 11.9341 3.97595 11.9451 3.99148 11.9527C4.007 11.9603 4.02405 11.9642 4.04133 11.9642C4.0586 11.9642 4.07565 11.9603 4.09117 11.9527C4.1067 11.9451 4.1203 11.9341 4.13095 11.9204L5.72428 9.89606C5.78261 9.82188 5.72997 9.7106 5.63466 9.7106Z"
      fill="currentColor"
    />
  ),
});

export const SortDescendingIcon: CreateIconType = createIcon({
  displayName: 'SortDescendingIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      d="M11.6609 5.88438L10.372 1.84274C10.3636 1.81569 10.3468 1.79207 10.324 1.77537C10.3012 1.75867 10.2736 1.74977 10.2454 1.75H9.14425C9.08593 1.75 9.03613 1.7871 9.01764 1.84274L7.71879 5.88438C7.71452 5.89722 7.71168 5.91148 7.71168 5.92575C7.71168 5.99851 7.77143 6.05843 7.84398 6.05843H8.64634C8.70609 6.05843 8.7573 6.01848 8.77437 5.96142L9.02333 5.08261H10.2895L10.5356 5.95999C10.5512 6.01705 10.6039 6.057 10.6636 6.057H11.5342C11.5485 6.057 11.5613 6.05557 11.5741 6.05129C11.6082 6.03988 11.6353 6.01705 11.6523 5.98567C11.668 5.95428 11.6708 5.91862 11.6609 5.88438V5.88438ZM9.15279 4.33934L9.61941 2.67161H9.70903L10.1657 4.33934H9.15279V4.33934ZM11.1942 11.3712H9.35053V11.3655L11.2369 8.67059C11.2526 8.64776 11.2611 8.62208 11.2611 8.59355V8.07425C11.2611 8.0015 11.2014 7.94158 11.1288 7.94158H8.22667C8.15411 7.94158 8.09436 8.0015 8.09436 8.07425V8.6877C8.09436 8.76046 8.15411 8.82038 8.22667 8.82038H9.97079V8.82609L8.07729 11.521C8.06148 11.5435 8.05304 11.5705 8.05311 11.598V12.1173C8.05311 12.1901 8.11286 12.25 8.18541 12.25H11.1928C11.2654 12.25 11.3251 12.1901 11.3251 12.1173V11.5039C11.3253 11.4865 11.3221 11.4693 11.3156 11.4532C11.3091 11.4371 11.2995 11.4225 11.2873 11.4101C11.2751 11.3978 11.2606 11.388 11.2447 11.3813C11.2287 11.3746 11.2116 11.3712 11.1942 11.3712V11.3712ZM4.13095 2.07956C4.12031 2.06591 4.10671 2.05488 4.09118 2.0473C4.07565 2.03971 4.0586 2.03577 4.04133 2.03577C4.02406 2.03577 4.00701 2.03971 3.99148 2.0473C3.97595 2.05488 3.96235 2.06591 3.9517 2.07956L2.35837 4.10394C2.29862 4.17955 2.35268 4.28941 2.448 4.28941H3.52919V11.8505C3.52919 11.9133 3.5804 11.9647 3.643 11.9647H4.43966C4.50226 11.9647 4.55347 11.9133 4.55347 11.8505V4.28941H5.63466C5.72997 4.28941 5.78403 4.17813 5.72428 4.10394L4.13095 2.07956Z"
      fill="currentColor"
    />
  ),
});

export const RefreshIcon: CreateIconType = createIcon({
  displayName: 'RefreshIcon',
  viewBox: '0 0 14 14',
  path: (
    <>
      <path
        d="M7.65662 1.87468C6.5177 1.72772 5.36205 1.95931 4.3677 2.53376C3.77407 2.8767 3.25758 3.3305 2.84374 3.86611V2.40624H1.82291V5.76041H5.17707V4.73958H3.473C3.83096 4.1992 4.31087 3.74553 4.87835 3.41769C5.67882 2.95525 6.60913 2.76882 7.52598 2.88712C8.44283 3.00542 9.29534 3.42189 9.95221 4.07238C10.6091 4.72286 11.0338 5.57127 11.1611 6.48692L11.2314 6.99248L12.2425 6.85196L12.1722 6.3464C12.0141 5.20897 11.4865 4.15506 10.6705 3.34702C9.85455 2.53898 8.79554 2.02164 7.65662 1.87468Z"
        fill="currentColor"
      />
      <path
        d="M2.83888 7.51307L2.76862 7.00751L1.75751 7.14803L1.82777 7.65359C1.98584 8.79102 2.5135 9.84493 3.32946 10.653C4.14543 11.461 5.20444 11.9784 6.34336 12.1253C7.48228 12.2723 8.63793 12.0407 9.63228 11.4662C10.2259 11.1233 10.7424 10.6695 11.1562 10.1339V11.5937H12.1771V8.23958H8.82291V9.26041H10.527C10.169 9.80079 9.68911 10.2545 9.12163 10.5823C8.32116 11.0447 7.39085 11.2312 6.474 11.1129C5.55715 10.9946 4.70464 10.5781 4.04777 9.92761C3.3909 9.27713 2.96613 8.42872 2.83888 7.51307Z"
        fill="currentColor"
      />
    </>
  ),
});

export const RotateCounterClockwiseIcon: CreateIconType = createIcon({
  displayName: 'RotateCounterClockwiseIcon',
  viewBox: '0 0 23 24',
  path: (
    <path
      d="M9.72266 2.93564C11.4467 2.57125 13.2351 2.74555 14.8623 3.43466C16.4891 4.1236 17.8782 5.295 18.8613 6.79501C19.8441 8.29458 20.3793 10.0587 20.4043 11.8673C20.4293 13.676 19.9436 15.4555 19.0029 16.9835C18.0621 18.5118 16.7061 19.7237 15.0996 20.461C13.4925 21.1986 11.7093 21.4259 9.97559 21.1134C8.24246 20.8009 6.64153 19.964 5.37109 18.713C4.97759 18.3255 4.97283 17.6914 5.36035 17.2979C5.74789 16.9048 6.38102 16.8998 6.77441 17.2872C7.76407 18.2618 9.00197 18.906 10.3311 19.1456C11.6596 19.385 13.027 19.2106 14.2646 18.6427C15.503 18.0743 16.561 17.1348 17.2998 15.9347C18.0388 14.7342 18.4241 13.3285 18.4043 11.8946C18.3844 10.4608 17.96 9.06788 17.1885 7.89072C16.4172 6.71404 15.3349 5.80702 14.082 5.27646C12.8297 4.74616 11.4576 4.61324 10.1357 4.89267C8.81368 5.17222 7.59363 5.85313 6.63086 6.85751C6.62071 6.8681 6.61021 6.87863 6.59961 6.88876L4.65039 8.75009H6.46875C7.02103 8.75009 7.46875 9.19781 7.46875 9.75009C7.4687 10.3023 7.021 10.7501 6.46875 10.7501H2.15625C1.604 10.7501 1.1563 10.3023 1.15625 9.75009V5.25009C1.15625 4.69781 1.60397 4.25009 2.15625 4.25009C2.70853 4.25009 3.15625 4.69781 3.15625 5.25009V7.41123L5.21875 5.44248C6.44903 4.1715 8.01328 3.297 9.72266 2.93564Z"
      fill="currentColor"
    />
  ),
});

export const RotateClockwiseIcon: CreateIconType = createIcon({
  displayName: 'RotateClockwiseIcon',
  viewBox: '0 0 23 24',
  path: (
    <path
      d="M8.13818 3.43421C9.76549 2.74525 11.5538 2.57061 13.2778 2.93519C14.9874 3.29673 16.5515 4.17168 17.7817 5.443L19.8442 7.41175V5.24964C19.8444 4.69752 20.2921 4.24964 20.8442 4.24964C21.3962 4.2499 21.844 4.69768 21.8442 5.24964V9.74964C21.8442 10.3018 21.3963 10.7494 20.8442 10.7496H16.5317C15.9794 10.7496 15.5317 10.3019 15.5317 9.74964C15.5319 9.19752 15.9796 8.74964 16.5317 8.74964H18.3481L16.3999 6.88929C16.3893 6.87914 16.3788 6.86864 16.3686 6.85804C15.4059 5.85346 14.186 5.17184 12.8638 4.89222C11.542 4.61274 10.1698 4.74576 8.91748 5.27601C7.66461 5.80654 6.58237 6.71357 5.81103 7.89026C5.03942 9.06743 4.61513 10.4603 4.59521 11.8942C4.57533 13.3281 4.96074 14.7336 5.6997 15.9342C6.43843 17.1343 7.49572 18.0738 8.73388 18.6422C9.97163 19.2104 11.3396 19.3846 12.6685 19.1451C13.9975 18.9057 15.2354 18.2622 16.2251 17.2877C16.6186 16.9002 17.2517 16.9049 17.6392 17.2985C18.0265 17.692 18.0218 18.325 17.6284 18.7125C16.3577 19.9637 14.7564 20.8016 13.0229 21.1139C11.2893 21.4262 9.50685 21.1973 7.8999 20.4596C6.29343 19.7221 4.93735 18.5105 3.99658 16.9821C3.05608 15.454 2.57008 13.6745 2.59521 11.8659C2.6204 10.0573 3.1553 8.29301 4.13818 6.79358C5.12141 5.29365 6.51133 4.12301 8.13818 3.43421Z"
      fill="currentColor"
    />
  ),
});

export const ShareExternalIcon: CreateIconType = createIcon({
  displayName: 'ShareExternalIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      d="M5.83333 1.75V2.91667H2.91667V11.0833H11.0833V8.16667H12.25V11.6667C12.25 11.8214 12.1885 11.9697 12.0791 12.0791C11.9697 12.1885 11.8214 12.25 11.6667 12.25H2.33333C2.17862 12.25 2.03025 12.1885 1.92085 12.0791C1.81146 11.9697 1.75 11.8214 1.75 11.6667V2.33333C1.75 2.17862 1.81146 2.03025 1.92085 1.92085C2.03025 1.81146 2.17862 1.75 2.33333 1.75H5.83333ZM10.3291 4.49575L7 7.82483L6.17517 7L9.50425 3.67092L7.58333 1.75H12.25V6.41667L10.3291 4.49575Z"
      fill="currentColor"
    />
  ),
});

export const AxisAlignedDimensionsIcon: CreateIconType = createIcon({
  displayName: 'AxisAlignedDimensionsIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.50173 5.81056C9.19214 5.53537 9.16425 5.06131 9.43944 4.75173L11.4394 2.50173C11.5818 2.34161 11.7858 2.25 12 2.25C12.2142 2.25 12.4182 2.34161 12.5606 2.50173L14.5606 4.75173C14.8357 5.06131 14.8079 5.53537 14.4983 5.81056C14.1887 6.08575 13.7146 6.05786 13.4394 5.74827L12.75 4.97265V6.4375L17.2558 9.06586L18 9.5V10.3683L18 15.604L19.7202 16.5971L19.3938 15.6123C19.2636 15.2191 19.4767 14.7947 19.8699 14.6644C20.2631 14.5342 20.6875 14.7473 20.8177 15.1405L21.7639 17.9962C21.8312 18.1994 21.8085 18.4217 21.7015 18.607C21.5944 18.7924 21.4133 18.9232 21.2036 18.9665L18.2575 19.575C17.8518 19.6588 17.4551 19.3978 17.3713 18.9922C17.2875 18.5865 17.5484 18.1898 17.9541 18.106L18.9702 17.8961L17.2797 16.9202L12.75 19.5625L12 20L11.25 19.5625L6.74613 16.9352L5.09988 17.8857L6.12028 18.089C6.52651 18.17 6.79021 18.5649 6.70927 18.9711C6.62833 19.3773 6.2334 19.641 5.82717 19.5601L2.85344 18.9676C2.64171 18.9254 2.45843 18.794 2.35048 18.607C2.24253 18.4201 2.22039 18.1957 2.28972 17.9912L3.26345 15.1196C3.39647 14.7273 3.8223 14.5172 4.21457 14.6502C4.60685 14.7832 4.81702 15.209 4.684 15.6013L4.34988 16.5867L6 15.634L6 10.3683V9.5L6.74424 9.06586L11.25 6.4375V4.97265L10.5606 5.74827C10.2854 6.05786 9.81131 6.08575 9.50173 5.81056ZM7.5 15.6384V11.2433L11.25 13.4308V17.8259L7.5 15.6384ZM12.75 17.8259V13.4308L16.5 11.2433V15.6384L12.75 17.8259ZM12 7.73656L15.7673 9.93414L12 12.1317L8.23271 9.93414L12 7.73656Z"
      fill="currentColor"
    />
  ),
});

export const ExplodeIcon: CreateIconType = createIcon({
  displayName: 'ExplodeIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.46967 6.53033C8.17678 6.23744 8.17678 5.76256 8.46967 5.46967L11.4697 2.46967C11.7626 2.17678 12.2374 2.17678 12.5303 2.46967L15.5303 5.46967C15.8232 5.76256 15.8232 6.23744 15.5303 6.53033C15.2374 6.82322 14.7626 6.82322 14.4697 6.53033L12.75 4.81066V9C12.75 9.41421 12.4142 9.75 12 9.75C11.5858 9.75 11.25 9.41421 11.25 9V4.81066L9.53033 6.53033C9.23744 6.82322 8.76256 6.82322 8.46967 6.53033ZM5.46967 8.46967C5.76256 8.17678 6.23744 8.17678 6.53033 8.46967C6.82322 8.76256 6.82322 9.23744 6.53033 9.53033L4.81066 11.25H9C9.41421 11.25 9.75 11.5858 9.75 12C9.75 12.4142 9.41421 12.75 9 12.75H4.81066L6.53033 14.4697C6.82322 14.7626 6.82322 15.2374 6.53033 15.5303C6.23744 15.8232 5.76256 15.8232 5.46967 15.5303L2.46967 12.5303C2.17678 12.2374 2.17678 11.7626 2.46967 11.4697L5.46967 8.46967ZM18.5303 8.46967C18.2374 8.17678 17.7626 8.17678 17.4697 8.46967C17.1768 8.76256 17.1768 9.23744 17.4697 9.53033L19.1893 11.25H15C14.5858 11.25 14.25 11.5858 14.25 12C14.25 12.4142 14.5858 12.75 15 12.75H19.1893L17.4697 14.4697C17.1768 14.7626 17.1768 15.2374 17.4697 15.5303C17.7626 15.8232 18.2374 15.8232 18.5303 15.5303L21.5303 12.5303C21.8232 12.2374 21.8232 11.7626 21.5303 11.4697L18.5303 8.46967ZM8.46967 18.5303C8.17678 18.2374 8.17678 17.7626 8.46967 17.4697C8.76256 17.1768 9.23744 17.1768 9.53033 17.4697L11.25 19.1893V15C11.25 14.5858 11.5858 14.25 12 14.25C12.4142 14.25 12.75 14.5858 12.75 15V19.1893L14.4697 17.4697C14.7626 17.1768 15.2374 17.1768 15.5303 17.4697C15.8232 17.7626 15.8232 18.2374 15.5303 18.5303L12.5303 21.5303C12.2374 21.8232 11.7626 21.8232 11.4697 21.5303L8.46967 18.5303Z"
      fill="currentColor"
    />
  ),
});

export const HighlightedFeaturesViewIcon: CreateIconType = createIcon({
  displayName: 'HighlightedFeaturesViewIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M15.3709 5.80065C14.2906 5.44131 13.163 5.25 12 5.25C8.04375 5.25 4.49849 7.46367 1.82186 10.9753C1.3604 11.5807 1.3604 12.4193 1.82186 13.0247C2.76555 14.2628 3.81721 15.3395 4.95678 16.2148L6.02711 15.1445C4.94771 14.3418 3.93596 13.3239 3.01483 12.1154C2.96275 12.0471 2.96275 11.9529 3.01483 11.8846C5.5005 8.6235 8.64611 6.75 12 6.75C12.7313 6.75 13.4526 6.83906 14.1594 7.01216L15.3709 5.80065Z"
        fill="currentColor"
      />
      <path
        d="M17.9729 8.85553L19.0432 7.7852C20.1828 8.66047 21.2345 9.73721 22.1781 10.9753C22.6396 11.5807 22.6396 12.4193 22.1781 13.0247C19.5015 16.5363 15.9563 18.75 12 18.75C10.837 18.75 9.70945 18.5587 8.62908 18.1993L9.84059 16.9878C10.5474 17.1609 11.2687 17.25 12 17.25C15.3539 17.25 18.4995 15.3765 20.9852 12.1154C21.0373 12.0471 21.0373 11.9529 20.9852 11.8846C20.0641 10.6761 19.0523 9.65818 17.9729 8.85553Z"
        fill="currentColor"
      />
      <path
        d="M12.167 9.00457C12.1117 9.00154 12.056 9 12 9C10.3431 9 9 10.3431 9 12C9 12.056 9.00154 12.1117 9.00457 12.167L12.167 9.00457Z"
        fill="currentColor"
      />
      <path
        d="M11.833 14.9954L14.9954 11.833C14.9985 11.8883 15 11.944 15 12C15 13.6569 13.6569 15 12 15C11.944 15 11.8883 14.9985 11.833 14.9954Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5303 3.46967C20.8232 3.76256 20.8232 4.23744 20.5303 4.53033L4.53033 20.5303C4.23744 20.8232 3.76256 20.8232 3.46967 20.5303C3.17678 20.2374 3.17678 19.7626 3.46967 19.4697L19.4697 3.46967C19.7626 3.17678 20.2374 3.17678 20.5303 3.46967Z"
        fill="currentColor"
      />
    </>
  ),
});

export const HighlightFocusedBodiesIcon: CreateIconType = createIcon({
  displayName: 'HighlightFocusedBodiesIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.25 2H12.75V7.05588C12.5054 7.01907 12.2549 7 12 7C11.7451 7 11.4946 7.01907 11.25 7.05588V2ZM7.05588 11.25H2V12.75H7.05588C7.01907 12.5054 7 12.2549 7 12C7 11.7451 7.01907 11.4946 7.05588 11.25ZM11.25 16.9441V22H12.75V16.9441C12.5054 16.9809 12.2549 17 12 17C11.7451 17 11.4946 16.9809 11.25 16.9441ZM16.9441 12.75H22V11.25H16.9441C16.9809 11.4946 17 11.7451 17 12C17 12.2549 16.9809 12.5054 16.9441 12.75ZM9.00001 2.4578C5.88994 3.43462 3.43462 5.88993 2.45781 9H4.04456C4.90521 6.71885 6.71886 4.90521 9.00001 4.04455V2.4578ZM15 4.04455V2.4578C18.1101 3.43462 20.5654 5.88993 21.5422 9H19.9555C19.0948 6.71885 17.2812 4.90521 15 4.04455ZM15 19.9554C17.2812 19.0948 19.0948 17.2811 19.9555 15H21.5422C20.5654 18.1101 18.1101 20.5654 15 21.5422V19.9554ZM4.04456 15C4.90522 17.2811 6.71886 19.0948 9.00001 19.9554V21.5422C5.88994 20.5654 3.43463 18.1101 2.45781 15H4.04456ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
      fill="currentColor"
    />
  ),
});

export const MeasureIcon: CreateIconType = createIcon({
  displayName: 'MeasureIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.43165 7.89889C3.05425 8.20958 2.95678 8.74758 3.2012 9.17093L3.27081 9.29149L4.30141 8.69647L4.33914 8.7618L7.98907 6.65451L9.58174 9.4131L5.93181 11.5204L5.96045 11.57L4.92985 12.165L5.00853 12.3013C5.25295 12.7247 5.76761 12.9092 6.22538 12.7378L10.563 11.1127L16.4833 21.367L18.6993 20.0877L12.3127 9.02578C12.355 8.94187 12.4215 8.86894 12.509 8.81844L13.482 8.25665C13.6477 8.16096 13.8455 8.17095 13.9972 8.2657L15.0653 7.64905C14.7482 7.09992 14.1154 6.81526 13.4942 6.94239L11.3618 7.37874L10.7932 6.39386L12.2373 4.76535C12.658 4.29092 12.7279 3.60052 12.4108 3.05139L11.3428 3.66803C11.3489 3.84682 11.2587 4.02307 11.093 4.11876L10.1199 4.68055C10.0325 4.73105 9.93609 4.75211 9.84226 4.74682L9.14323 3.53608L7.76393 4.33241L6.92729 4.81545L7.00779 4.95489L3.43165 7.89889Z"
      fill="currentColor"
    />
  ),
});

export const OptimalBoundingBoxIcon: CreateIconType = createIcon({
  displayName: 'OptimalBoundingBoxIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 7.85797V7L3.77217 6.57102L12 2L20.2278 6.57102L21 7V7.85797V17L12.75 21.5833L12 22L11.25 21.5833L3 17V7.85797ZM4.5 13.7268V8.6913L11.25 12.4413V19.8674L7.11308 17.5691V15.2355L4.5 13.7268ZM12.75 19.8674V12.4413L19.5 8.6913V13.7268L16.8869 15.2355V17.5691L12.75 19.8674ZM14.3826 5.0396L18.6835 7.42898L12 11.142L5.31652 7.42898L9.61741 5.0396L12 6.41519L14.3826 5.0396Z"
      fill="currentColor"
    />
  ),
});

export const PMIIcon: CreateIconType = createIcon({
  displayName: 'PMIIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.5 5.5H8.5V17.5H20.5V5.5ZM8.5 4H7V5.5V10.9838C6.97796 11.0013 6.95668 11.0203 6.93628 11.0407L2.50598 15.471L2.5455 14.5621C2.5635 14.1483 2.24261 13.7982 1.82879 13.7802C1.41497 13.7622 1.06491 14.0831 1.04692 14.4969L0.923648 17.3321C0.914516 17.5422 0.993955 17.7464 1.14261 17.895C1.29127 18.0437 1.49549 18.1231 1.70552 18.114L4.54072 17.9907C4.95454 17.9727 5.27543 17.6227 5.25744 17.2089C5.23944 16.795 4.88939 16.4742 4.47557 16.4921L3.56664 16.5317L7 13.0983V17.5V19H8.5H20.5H22V17.5V5.5V4H20.5H8.5ZM13.8866 7.08691C13.9756 7.01952 14.0789 7 14.1697 7H15.2323C15.3339 7 15.4387 7.02349 15.5311 7.08794C15.6248 7.15317 15.6854 7.24624 15.7206 7.34806L18.3802 14.9427C18.4244 15.0544 18.4233 15.174 18.3768 15.2853L18.3739 15.2921L18.3707 15.2987C18.2994 15.4449 18.1649 15.5 18.0414 15.5H17.0524C16.9706 15.5 16.8819 15.4803 16.8028 15.4231C16.7238 15.366 16.675 15.2863 16.6477 15.2042L15.9987 13.3544H13.2312L12.5717 15.2365C12.5422 15.3121 12.4946 15.379 12.4286 15.4297L12.418 15.4379C12.3696 15.4709 12.3191 15.4841 12.2839 15.4907C12.2462 15.4977 12.2074 15.5 12.1707 15.5H11.3606C11.3021 15.5 11.2372 15.4869 11.1758 15.4492C11.1137 15.411 11.0701 15.3566 11.0419 15.2987C10.9812 15.1744 10.9954 15.0451 11.0285 14.9433L11.0305 14.9372L13.7124 7.33883C13.7403 7.25452 13.7903 7.15248 13.8866 7.08691ZM14.622 9.22202L15.542 11.841H13.6764L14.622 9.22202Z"
      fill="currentColor"
    />
  ),
});

export const ResetViewIcon: CreateIconType = createIcon({
  displayName: 'ResetViewIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 3H6C4.34315 3 3 4.34315 3 6V10H4.5V6C4.5 5.17157 5.17157 4.5 6 4.5H10V3ZM14 4.5V3H18C19.6569 3 21 4.34315 21 6V10H19.5V6C19.5 5.17157 18.8284 4.5 18 4.5H14ZM14 19.5H18C18.8284 19.5 19.5 18.8284 19.5 18V14H21V18C21 19.6569 19.6569 21 18 21H14V19.5ZM4.5 14V18C4.5 18.8284 5.17157 19.5 6 19.5H10V21H6C4.34315 21 3 19.6569 3 18V14H4.5Z"
        fill="currentColor"
      />
      <circle cx="12" cy="12" r="2" fill="currentColor" />
    </>
  ),
});

export const SelectionToolIcon: CreateIconType = createIcon({
  displayName: 'SelectionToolIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 2L21 15.2879H14.2815C14.2808 15.2879 14.2803 15.2886 14.2806 15.2893L16.52 20.6031L14.21 21.5L12.0406 16.3523C12.0404 16.3519 12.0401 16.3517 12.0398 16.3517C12.0395 16.3516 12.0392 16.3517 12.039 16.3519L7 21.1346V2ZM9 6.5L16.5 13.5H12L9 16.5V6.5Z"
      fill="currentColor"
    />
  ),
});

export const WireframeIcon: CreateIconType = createIcon({
  displayName: 'WireframeIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 20.5C12.5065 20.5 13.3688 20.0504 14.1939 18.4002C14.533 17.722 14.8241 16.9115 15.0448 16H8.95519C9.17591 16.9115 9.46698 17.722 9.80611 18.4002C10.6312 20.0504 11.4935 20.5 12 20.5ZM8.67097 14.5C8.56052 13.7132 8.5 12.8749 8.5 12C8.5 11.308 8.53786 10.6388 8.60835 10H15.3917C15.4621 10.6388 15.5 11.308 15.5 12C15.5 12.8749 15.4395 13.7132 15.329 14.5H8.67097ZM16.584 16C16.2427 17.562 15.7078 18.9159 15.0398 19.9403C16.9585 19.2053 18.5429 17.7949 19.5019 16H16.584ZM20.1264 14.5H16.8425C16.9453 13.7009 17 12.8632 17 12C17 11.3151 16.9656 10.6462 16.9 10H20.2634C20.4181 10.6414 20.5 11.3111 20.5 12C20.5 12.8701 20.3693 13.7096 20.1264 14.5ZM7.15752 14.5H3.8736C3.63072 13.7096 3.5 12.8701 3.5 12C3.5 11.3111 3.58195 10.6414 3.73663 10H7.10002C7.03443 10.6462 7 11.3151 7 12C7 12.8632 7.05469 13.7009 7.15752 14.5ZM4.4981 16H7.41604C7.75727 17.562 8.29224 18.9159 8.9602 19.9403C7.0415 19.2053 5.45714 17.7949 4.4981 16ZM8.84334 8.5H15.1567C14.927 7.38355 14.5938 6.39965 14.1939 5.59975C13.3688 3.94957 12.5065 3.5 12 3.5C11.4935 3.5 10.6312 3.94957 9.80611 5.59975C9.40616 6.39965 9.07305 7.38355 8.84334 8.5ZM16.6852 8.5H19.7483C18.8288 6.46775 17.1333 4.86165 15.0398 4.05969C15.7781 5.19191 16.3539 6.7267 16.6852 8.5ZM8.9602 4.05969C8.22193 5.19191 7.64613 6.7267 7.3148 8.5H4.25174C5.17118 6.46775 6.86667 4.86165 8.9602 4.05969Z"
      fill="currentColor"
    />
  ),
});

export const LoopSelectionPointerIcon: CreateIconType = createIcon({
  displayName: 'LoopSelectionPointerIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5762 15.1396H12.6406L14.2744 18.7549C14.5019 19.2581 14.2786 19.8506 13.7754 20.0781C13.2723 20.3054 12.6797 20.0821 12.4521 19.5791L10.7764 15.873L6 20.6758V2.73145L19.5762 15.1396ZM8 15.8291L10.6748 13.1396H14.4229L8 7.26855V15.8291Z"
        fill="currentColor"
      />
      <path
        d="M17.5 5.73406C17.5 5.10365 16.9889 4.59253 16.3585 4.59249C15.728 4.59249 15.2169 5.10363 15.2169 5.73406C15.2169 6.36447 15.728 6.87563 16.3585 6.87563V8.3756L16.088 8.36192C14.8448 8.23551 13.8566 7.24687 13.7306 6.00359L13.7169 5.73406C13.7169 4.27522 14.8996 3.09253 16.3585 3.09253L16.628 3.1062C17.9602 3.24125 19 4.36624 19 5.73406L18.9863 6.00359C18.8513 7.33577 17.7263 8.37556 16.3585 8.3756V6.87563C16.9888 6.8756 17.5 6.36444 17.5 5.73406Z"
        fill="currentColor"
      />
    </>
  ),
});

export const EdgeSelectionPointerIcon: CreateIconType = createIcon({
  displayName: 'EdgeSelectionPointerIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5762 15.1396H12.6406L14.2744 18.7549C14.5019 19.2581 14.2786 19.8506 13.7754 20.0781C13.2723 20.3054 12.6797 20.0821 12.4521 19.5791L10.7764 15.873L6 20.6758V2.73145L19.5762 15.1396ZM8 15.8291L10.6748 13.1396H14.4229L8 7.26855V15.8291Z"
        fill="currentColor"
      />
      <path
        d="M19.0001 4.98413V6.48413H13.7169V4.98413H19.0001Z"
        fill="currentColor"
      />
    </>
  ),
});

export const CopyToClipboardIcon: CreateIconType = createIcon({
  displayName: 'CopyToClipboardIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 2C8.89543 2 8 2.89543 8 4L6 4C4.89543 4 4 4.89543 4 6V20C4 21.1046 4.89543 22 6 22H16C17.1046 22 18 21.1046 18 20V17H16.5V20C16.5 20.2761 16.2761 20.5 16 20.5H6C5.72386 20.5 5.5 20.2761 5.5 20V6C5.5 5.72386 5.72386 5.5 6 5.5H16C16.2761 5.5 16.5 5.72386 16.5 6V11H18V6C18 4.89543 17.1046 4 16 4H14C14 2.89543 13.1046 2 12 2H10ZM12 3.5H10C9.72386 3.5 9.5 3.72386 9.5 4L12.5 4C12.5 3.72386 12.2761 3.5 12 3.5Z"
        fill="currentColor"
      />
      <path
        d="M7.5 6.75C7.08579 6.75 6.75 7.08579 6.75 7.5C6.75 7.91421 7.08579 8.25 7.5 8.25H14.5C14.9142 8.25 15.25 7.91421 15.25 7.5C15.25 7.08579 14.9142 6.75 14.5 6.75H7.5Z"
        fill="currentColor"
      />
      <path
        d="M13.2197 10.7197C13.5126 10.4268 13.9874 10.4268 14.2803 10.7197C14.5732 11.0126 14.5732 11.4874 14.2803 11.7803L12.8107 13.25H21.7708C22.185 13.25 22.5208 13.5858 22.5208 14C22.5208 14.4142 22.185 14.75 21.7708 14.75H12.8107L14.2803 16.2197C14.5732 16.5126 14.5732 16.9874 14.2803 17.2803C13.9874 17.5732 13.5126 17.5732 13.2197 17.2803L10.4697 14.5303C10.329 14.3897 10.25 14.1989 10.25 14C10.25 13.8011 10.329 13.6103 10.4697 13.4697L13.2197 10.7197Z"
        fill="currentColor"
      />
    </>
  ),
});

export const LineItemIcon: CreateIconType = createIcon({
  displayName: 'LineItemIcon',
  viewBox: '0 0 20 20',
  path: (
    <>
      <path
        d="M4.58334 9.16663C4.35322 9.16663 4.16667 9.35317 4.16667 9.58329V12.9166C4.16667 13.1467 4.35322 13.3333 4.58334 13.3333H7.91667C8.14679 13.3333 8.33334 13.1467 8.33334 12.9166V9.58329C8.33334 9.35317 8.14679 9.16663 7.91667 9.16663H4.58334Z"
        fill="currentColor"
      />
      <path
        d="M10 9.58329C9.76989 9.58329 9.58334 9.76984 9.58334 9.99996V10.4166C9.58334 10.6467 9.76989 10.8333 10 10.8333H15C15.2301 10.8333 15.4167 10.6467 15.4167 10.4166V9.99996C15.4167 9.76984 15.2301 9.58329 15 9.58329H10Z"
        fill="currentColor"
      />
      <path
        d="M10 11.6666C9.76989 11.6666 9.58334 11.8532 9.58334 12.0833V12.5C9.58334 12.7301 9.76989 12.9166 10 12.9166H15C15.2301 12.9166 15.4167 12.7301 15.4167 12.5V12.0833C15.4167 11.8532 15.2301 11.6666 15 11.6666H10Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66667 6.16663V13.1666C1.66667 14.1 1.66667 14.5668 1.84833 14.9233C2.00812 15.2369 2.26308 15.4918 2.57669 15.6516C2.93321 15.8333 3.39992 15.8333 4.33334 15.8333H15.6667C16.6001 15.8333 17.0668 15.8333 17.4233 15.6516C17.7369 15.4918 17.9919 15.2369 18.1517 14.9233C18.3333 14.5668 18.3333 14.1 18.3333 13.1666V6.16663C18.3333 5.46656 18.3333 5.11653 18.1971 4.84914C18.0773 4.61394 17.886 4.42271 17.6508 4.30287C17.3834 4.16663 17.0334 4.16663 16.3333 4.16663H3.66667C2.96661 4.16663 2.61657 4.16663 2.34918 4.30287C2.11398 4.42271 1.92276 4.61394 1.80291 4.84914C1.66667 5.11653 1.66667 5.46656 1.66667 6.16663ZM3.66667 5.41663H5.00001V6.66663H2.91667V6.16663C2.91667 5.79597 2.91764 5.59315 2.92955 5.44742L2.93098 5.43094L2.94746 5.4295C3.0932 5.4176 3.29601 5.41663 3.66667 5.41663ZM6.25001 6.66663V5.41663H16.3333C16.704 5.41663 16.9068 5.4176 17.0525 5.4295L17.069 5.43094L17.0705 5.44742C17.0824 5.59315 17.0833 5.79597 17.0833 6.16663V6.70219C17.0182 6.67916 16.9481 6.66663 16.875 6.66663H6.25001ZM16.875 7.91663C16.9481 7.91663 17.0182 7.90409 17.0833 7.88106V13.1666C17.0833 13.654 17.0824 13.9443 17.0648 14.1595C17.0541 14.2908 17.0399 14.346 17.0353 14.3609C16.9961 14.4353 16.9353 14.4961 16.8609 14.5353C16.8461 14.5398 16.7909 14.554 16.6595 14.5647C16.4443 14.5823 16.154 14.5833 15.6667 14.5833H4.33334C3.846 14.5833 3.55568 14.5823 3.34047 14.5647C3.20912 14.554 3.15391 14.5398 3.13911 14.5353C3.06471 14.4961 3.00391 14.4353 2.96471 14.3609C2.96012 14.3461 2.94596 14.2908 2.93523 14.1595C2.91764 13.9443 2.91667 13.654 2.91667 13.1666V7.91663H16.875ZM17.0338 14.3652L17.0347 14.3626C17.0341 14.3644 17.0338 14.3652 17.0338 14.3652ZM16.8652 14.5337C16.8653 14.5338 16.8645 14.5341 16.8627 14.5347L16.8652 14.5337ZM3.1348 14.5337L3.13732 14.5347C3.13554 14.5341 3.13475 14.5338 3.1348 14.5337ZM2.96622 14.3652C2.96621 14.3652 2.96626 14.3653 2.96622 14.3652V14.3652Z"
        fill="currentColor"
      />
    </>
  ),
});

export const CreateLineItemIcon: CreateIconType = createIcon({
  displayName: 'CreateLineItemIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 7.4V11.9962C21.5378 11.7185 21.0339 11.503 20.5 11.3613V9.5H3.75C3.66234 9.5 3.57819 9.48496 3.5 9.45732V15.8C3.5 16.3848 3.50117 16.7332 3.52227 16.9914C3.53514 17.1491 3.55214 17.2153 3.55765 17.2331C3.60469 17.3224 3.67765 17.3953 3.76693 17.4424C3.78469 17.4479 3.85094 17.4649 4.00855 17.4777C4.26681 17.4988 4.6152 17.5 5.2 17.5H13.1878C13.2322 18.0227 13.3455 18.5257 13.5186 19H5.2C4.0799 19 3.51984 19 3.09202 18.782C2.71569 18.5903 2.40973 18.2843 2.21799 17.908C2 17.4802 2 16.9201 2 15.8V7.4C2 6.55992 2 6.13988 2.16349 5.81901C2.3073 5.53677 2.53677 5.3073 2.81901 5.16349C3.13988 5 3.55992 5 4.4 5H19.6C20.4401 5 20.8601 5 21.181 5.16349C21.4632 5.3073 21.6927 5.53677 21.8365 5.81901C22 6.13988 22 6.55992 22 7.4ZM4.4 6.5H6V8H3.75C3.66234 8 3.57819 8.01504 3.5 8.04268V7.4C3.5 6.95521 3.50117 6.71183 3.51545 6.53695L3.51717 6.51717L3.53695 6.51545C3.71183 6.50117 3.95521 6.5 4.4 6.5ZM7.5 8V6.5H19.6C20.0448 6.5 20.2882 6.50117 20.463 6.51545L20.4828 6.51717L20.4845 6.53695C20.4988 6.71183 20.5 6.95521 20.5 7.4V8H7.5ZM3.76175 17.4405L3.76478 17.4417C3.76264 17.441 3.76169 17.4406 3.76175 17.4405ZM3.55945 17.2383C3.55945 17.2383 3.5595 17.2384 3.55945 17.2383V17.2383Z"
        fill="currentColor"
      />
      <path
        d="M12 11.5H17.0516C16.1686 11.8128 15.3834 12.3322 14.7541 13H12C11.7239 13 11.5 12.7761 11.5 12.5V12C11.5 11.7239 11.7239 11.5 12 11.5Z"
        fill="currentColor"
      />
      <path
        d="M12 14H13.9962C13.7185 14.4622 13.503 14.9661 13.3613 15.5H12C11.7239 15.5 11.5 15.2761 11.5 15V14.5C11.5 14.2239 11.7239 14 12 14Z"
        fill="currentColor"
      />
      <path
        d="M5.5 11C5.22386 11 5 11.2239 5 11.5V15.5C5 15.7761 5.22386 16 5.5 16H9.5C9.77614 16 10 15.7761 10 15.5V11.5C10 11.2239 9.77614 11 9.5 11H5.5Z"
        fill="currentColor"
      />
      <path
        d="M20 13.5311C20 12.9788 19.5523 12.5311 19 12.5311C18.4477 12.5311 18 12.9788 18 13.5311V15.9999H15.5312C14.979 15.9999 14.5312 16.4476 14.5312 16.9999C14.5312 17.5522 14.979 17.9999 15.5312 17.9999H18V20.4686C18 21.0209 18.4477 21.4686 19 21.4686C19.5523 21.4686 20 21.0209 20 20.4686V17.9999H22.4688C23.021 17.9999 23.4688 17.5522 23.4688 16.9999C23.4688 16.4476 23.021 15.9999 22.4688 15.9999H20V13.5311Z"
        fill="currentColor"
      />
    </>
  ),
});

export const MalwareIcon: CreateIconType = createIcon({
  displayName: 'MalwareIcon',
  viewBox: '0 0 12 12',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.95474 2.09375C6.81174 1.81087 6.1192 1.12388 5.99998 1C5.88077 1.12388 5.18825 1.81087 4.04526 2.09375C2.78261 2.40625 1.51995 2.40625 1.51995 2.40625C1.51995 2.40625 1.23936 5.84375 2.78261 8.03125C4.23068 10.0838 5.81165 10.9074 5.99998 11C6.18832 10.9074 7.76932 10.0838 9.21739 8.03125C10.7606 5.84375 10.48 2.40625 10.48 2.40625C10.48 2.40625 9.21739 2.40625 7.95474 2.09375ZM4.5985 4.06817C4.45205 3.92172 4.21461 3.92172 4.06817 4.06817C3.92172 4.21461 3.92172 4.45205 4.06817 4.5985L5.46967 6L4.06817 7.4015C3.92172 7.54795 3.92172 7.78538 4.06817 7.93183C4.21461 8.07828 4.45205 8.07828 4.5985 7.93183L6 6.53033L7.4015 7.93183C7.54795 8.07828 7.78538 8.07828 7.93183 7.93183C8.07828 7.78538 8.07828 7.54795 7.93183 7.4015L6.53033 6L7.93183 4.5985C8.07828 4.45205 8.07828 4.21461 7.93183 4.06817C7.78538 3.92172 7.54795 3.92172 7.4015 4.06817L6 5.46967L4.5985 4.06817Z"
      fill="currentColor"
    />
  ),
});

export const UnzipIcon: CreateIconType = createIcon({
  displayName: 'UnzipIcon',
  viewBox: '0 0 20 20',
  path: (
    <>
      <path
        d="M3.51503 2.57652C3.67482 2.26292 3.92979 2.00795 4.24339 1.84816C4.59991 1.6665 5.06662 1.6665 6.00004 1.6665H12.2288C12.6365 1.6665 12.8403 1.6665 13.0321 1.71255C13.2022 1.75338 13.3647 1.82072 13.5138 1.9121C13.682 2.01517 13.8262 2.1593 14.1144 2.44755L15.8857 4.21879C16.1739 4.50704 16.318 4.65117 16.4211 4.81936C16.5125 4.96848 16.5798 5.13106 16.6207 5.30112C16.6667 5.49293 16.6667 5.69676 16.6667 6.10441V9.40807C16.2664 9.28892 15.848 9.21159 15.4167 9.18116V6.10441C15.4167 5.8897 15.4164 5.76975 15.4123 5.67892C15.4097 5.62245 15.4063 5.59905 15.4052 5.59292C15.395 5.55041 15.3782 5.50977 15.3553 5.47249C15.3593 5.47897 15.353 5.46536 15.2995 5.40668C15.2382 5.33952 15.1536 5.25449 15.0018 5.10267L13.2305 3.33144C13.0787 3.17962 12.9937 3.09501 12.9265 3.03372C12.8848 2.9956 12.8658 2.98146 12.8607 2.9779C12.8234 2.95506 12.7828 2.93822 12.7403 2.92802C12.7477 2.92979 12.7337 2.92458 12.6543 2.92096C12.5635 2.9168 12.4435 2.9165 12.2288 2.9165H8.75004V4.15348C8.75004 4.27573 8.65094 4.37484 8.52869 4.37484H7.20056C7.07831 4.37484 6.97921 4.27573 6.97921 4.15348V2.9165H6.00004C5.5127 2.9165 5.22238 2.91748 5.00717 2.93506C4.87582 2.94579 4.82061 2.95995 4.80581 2.96454C4.73141 3.00374 4.67061 3.06454 4.63141 3.13894C4.62682 3.15374 4.61266 3.20895 4.60193 3.3403C4.58435 3.55551 4.58337 3.84583 4.58337 4.33317V15.6665C4.58337 16.1538 4.58435 16.4442 4.60193 16.6594C4.61266 16.7907 4.62682 16.8459 4.63141 16.8607C4.67061 16.9351 4.73141 16.9959 4.80581 17.0351C4.82061 17.0397 4.87582 17.0539 5.00717 17.0646C5.22238 17.0822 5.5127 17.0832 6.00004 17.0832H9.54973C9.72011 17.5286 9.94354 17.9479 10.2123 18.3332H6.00004C5.06662 18.3332 4.59991 18.3332 4.24339 18.1515C3.92979 17.9917 3.67482 17.7368 3.51503 17.4232C3.33337 17.0666 3.33337 16.5999 3.33337 15.6665V4.33317C3.33337 3.39975 3.33337 2.93304 3.51503 2.57652Z"
        fill="currentColor"
      />
      <path
        d="M6.97921 6.36702C6.97921 6.24477 7.07831 6.14567 7.20056 6.14567H8.52869C8.65094 6.14567 8.75004 6.24477 8.75004 6.36702V7.69515C8.75004 7.8174 8.65094 7.9165 8.52869 7.9165H7.20056C7.07831 7.9165 6.97921 7.8174 6.97921 7.69515V6.36702Z"
        fill="currentColor"
      />
      <path
        d="M7.20056 9.68734C7.07831 9.68734 6.97921 9.78644 6.97921 9.90869V11.2368C6.97921 11.3591 7.07831 11.4582 7.20056 11.4582H8.52869C8.65094 11.4582 8.75004 11.3591 8.75004 11.2368V9.90869C8.75004 9.78644 8.65094 9.68734 8.52869 9.68734H7.20056Z"
        fill="currentColor"
      />
      <path
        d="M8.75004 4.59619C8.75004 4.47394 8.84914 4.37484 8.97139 4.37484H10.2995C10.4218 4.37484 10.5209 4.47394 10.5209 4.59619V5.92432C10.5209 6.04657 10.4218 6.14567 10.2995 6.14567H8.97139C8.84914 6.14567 8.75004 6.04657 8.75004 5.92432V4.59619Z"
        fill="currentColor"
      />
      <path
        d="M8.97139 7.9165C8.84914 7.9165 8.75004 8.01561 8.75004 8.13786V9.46598C8.75004 9.58823 8.84914 9.68734 8.97139 9.68734H10.2995C10.4218 9.68734 10.5209 9.58823 10.5209 9.46598V8.13786C10.5209 8.01561 10.4218 7.9165 10.2995 7.9165H8.97139Z"
        fill="currentColor"
      />
      <path
        d="M8.75004 11.6795C8.75004 11.5573 8.84914 11.4582 8.97139 11.4582H10.2995C10.4218 11.4582 10.5209 11.5573 10.5209 11.6795V13.0076C10.5209 13.1299 10.4218 13.229 10.2995 13.229H8.97139C8.84914 13.229 8.75004 13.1299 8.75004 13.0076V11.6795Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.1667 14.9998C19.1667 17.301 17.3012 19.1665 15 19.1665C12.6989 19.1665 10.8334 17.301 10.8334 14.9998C10.8334 12.6987 12.6989 10.8332 15 10.8332C17.3012 10.8332 19.1667 12.6987 19.1667 14.9998ZM13.6742 13.049C13.329 13.049 13.0492 13.3288 13.0492 13.674C13.0492 14.0192 13.329 14.299 13.6742 14.299H14.817L13.2323 15.8837C12.9882 16.1278 12.9882 16.5235 13.2323 16.7676C13.4764 17.0117 13.8721 17.0117 14.1162 16.7676L15.7009 15.1829V16.3257C15.7009 16.6708 15.9807 16.9507 16.3259 16.9507C16.671 16.9507 16.9509 16.6708 16.9509 16.3257V13.049H13.6742Z"
        fill="currentColor"
      />
    </>
  ),
});

export const AssistanceIcon: CreateIconType = createIcon({
  displayName: 'AssistanceIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M14.3809 21C14.6348 21 14.8203 20.8144 14.8691 20.5508C15.5625 15.209 16.3145 14.3887 21.6074 13.8027C21.8809 13.7734 22.0664 13.5781 22.0664 13.3144C22.0664 13.0605 21.8809 12.8652 21.6074 12.8359C16.3145 12.25 15.5625 11.4297 14.8691 6.07813C14.8203 5.81445 14.6348 5.63867 14.3809 5.63867C14.127 5.63867 13.9414 5.81445 13.9023 6.07813C13.209 11.4297 12.4473 12.25 7.16406 12.8359C6.88086 12.8652 6.69531 13.0605 6.69531 13.3144C6.69531 13.5781 6.88086 13.7734 7.16406 13.8027C12.4375 14.4961 13.1699 15.209 13.9023 20.5508C13.9414 20.8144 14.127 21 14.3809 21ZM7.75977 10.1992C7.94531 10.1992 8.07227 10.0723 8.0918 9.89651C8.44336 7.28906 8.53125 7.28906 11.2266 6.77149C11.3926 6.74219 11.5195 6.625 11.5195 6.43945C11.5195 6.26367 11.3926 6.13672 11.2266 6.11719C8.53125 5.73633 8.43359 5.64844 8.0918 3.00195C8.07227 2.81641 7.94531 2.68945 7.75977 2.68945C7.58398 2.68945 7.45703 2.81641 7.42773 3.01172C7.11523 5.61914 6.96875 5.60938 4.29297 6.11719C4.12695 6.14649 4 6.26367 4 6.43945C4 6.63477 4.12695 6.74219 4.33203 6.77149C6.98828 7.20117 7.11523 7.26953 7.42773 9.87691C7.45703 10.0723 7.58398 10.1992 7.75977 10.1992Z"
        fill="currentColor"
      />
    </>
  ),
});

export const AssistanceRejectedIcon: CreateIconType = createIcon({
  displayName: 'AssistanceRejectedIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M14.8691 6.07813C14.8778 6.14495 14.8864 6.21106 14.8951 6.27647L13.7014 7.47018C13.7714 7.04379 13.8372 6.58097 13.9023 6.07813C13.9414 5.81445 14.127 5.63867 14.3809 5.63867C14.6348 5.63867 14.8203 5.81445 14.8691 6.07813Z"
        fill="currentColor"
      />
      <path
        d="M7.16406 12.8359C7.64817 12.7822 8.09432 12.7266 8.50593 12.6656L7.34484 13.8267L7.16406 13.8027C6.88086 13.7734 6.69531 13.5781 6.69531 13.3144C6.69531 13.0605 6.88086 12.8652 7.16406 12.8359Z"
        fill="currentColor"
      />
      <path
        d="M13.9023 20.5508C13.4813 17.48 13.0603 15.9389 11.7766 15.0519L16.0983 10.7301C16.9864 12.075 18.5288 12.4951 21.6074 12.8359C21.8809 12.8652 22.0664 13.0605 22.0664 13.3144C22.0664 13.5781 21.8809 13.7734 21.6074 13.8027C16.3145 14.3887 15.5625 15.209 14.8691 20.5508C14.8203 20.8144 14.6348 21 14.3809 21C14.127 21 13.9414 20.8144 13.9023 20.5508Z"
        fill="currentColor"
      />
      <path
        d="M7.75977 10.1992C7.94531 10.1992 8.07227 10.0723 8.0918 9.89651C8.44104 7.30627 8.53008 7.28918 11.1735 6.78167L11.2266 6.77149C11.3926 6.74219 11.5195 6.625 11.5195 6.43945C11.5195 6.26367 11.3926 6.13672 11.2266 6.11719C8.53125 5.73633 8.43359 5.64844 8.0918 3.00195C8.07227 2.81641 7.94531 2.68945 7.75977 2.68945C7.58398 2.68945 7.45703 2.81641 7.42773 3.01172C7.11977 5.5813 6.97304 5.60912 4.40789 6.0954L4.29297 6.11719C4.12695 6.14649 4 6.26367 4 6.43945C4 6.63477 4.12695 6.74219 4.33203 6.77149C6.98828 7.20117 7.11523 7.26953 7.42773 9.87691C7.45703 10.0723 7.58398 10.1992 7.75977 10.1992Z"
        fill="currentColor"
      />
      <path
        d="M19.5303 5.53033C19.8232 5.23744 19.8232 4.76256 19.5303 4.46967C19.2374 4.17678 18.7626 4.17678 18.4697 4.46967L4.46967 18.4697C4.17678 18.7626 4.17678 19.2374 4.46967 19.5303C4.76256 19.8232 5.23744 19.8232 5.53033 19.5303L19.5303 5.53033Z"
        fill="currentColor"
      />
    </>
  ),
});

export const AssistanceAvailableIcon: CreateIconType = createIcon({
  displayName: 'AssistanceAvailableIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.16406 12.8359C6.88086 12.8652 6.69531 13.0605 6.69531 13.3144C6.69531 13.5781 6.88086 13.7734 7.16406 13.8027C7.19805 13.8072 7.23186 13.8117 7.26547 13.8161C7.26794 13.8165 7.27041 13.8168 7.27287 13.8171C7.52492 13.8507 7.76643 13.8844 7.99789 13.9187C8.38285 13.9758 8.74004 14.0346 9.07184 14.0977C12.119 14.6766 13.0238 15.6078 13.6178 18.75C13.6736 19.0453 13.7266 19.36 13.7785 19.6959C13.8116 19.9109 13.8443 20.1345 13.8769 20.3671C13.8795 20.3857 13.8821 20.4043 13.8847 20.423C13.8906 20.4653 13.8965 20.5079 13.9023 20.5508C13.9414 20.8144 14.127 21 14.3809 21C14.6348 21 14.8203 20.8144 14.8691 20.5508C14.875 20.5055 14.8809 20.4605 14.8868 20.4158C14.8873 20.4121 14.8877 20.4084 14.8882 20.4047C14.9206 20.1594 14.9533 19.9239 14.9866 19.6977C15.0363 19.3598 15.0875 19.0427 15.1418 18.745C15.7112 15.6192 16.6127 14.6235 19.599 14.0816C19.9538 14.0172 20.3381 13.9592 20.7546 13.9048C20.9921 13.8738 21.24 13.844 21.499 13.8148C21.5002 13.8147 21.5014 13.8146 21.5026 13.8144C21.5373 13.8105 21.5723 13.8066 21.6074 13.8027C21.8809 13.7734 22.0664 13.5781 22.0664 13.3144C22.0664 13.0605 21.8809 12.8652 21.6074 12.8359C21.5723 12.832 21.5373 12.8281 21.5026 12.8242C21.5014 12.8241 21.5002 12.8239 21.499 12.8238C21.2395 12.7946 20.9911 12.7647 20.7533 12.7336C20.3372 12.6793 19.9535 12.6214 19.5991 12.557C16.6223 12.0168 15.717 11.0249 15.1473 7.91743C15.0912 7.61161 15.0384 7.2853 14.9872 6.9369C14.9536 6.70894 14.9208 6.47152 14.8882 6.22421C14.8874 6.21799 14.8866 6.21177 14.8857 6.20554C14.8802 6.16336 14.8746 6.12089 14.8691 6.07813C14.8203 5.81445 14.6348 5.63867 14.3809 5.63867C14.127 5.63867 13.9414 5.81445 13.9023 6.07813C13.8968 6.12089 13.8913 6.16337 13.8857 6.20555C13.8832 6.22426 13.8808 6.24291 13.8783 6.2615C13.847 6.4975 13.8155 6.72444 13.7833 6.9427C13.7323 7.2888 13.6797 7.61309 13.6238 7.91713C13.0468 11.0568 12.1239 12.0369 9.07685 12.5736C8.74682 12.6317 8.39188 12.6846 8.00976 12.7345C7.78079 12.7644 7.54206 12.7933 7.29308 12.8215C7.28382 12.8225 7.27455 12.8236 7.26526 12.8246C7.23171 12.8284 7.19798 12.8322 7.16406 12.8359ZM11.7953 13.3452C12.3505 13.602 12.8551 13.9319 13.2961 14.3723C13.7608 14.8364 14.1042 15.3726 14.3696 15.9658C14.6339 15.3606 14.9782 14.8121 15.4473 14.3382C15.8712 13.9099 16.3628 13.5795 16.9158 13.3191C16.3625 13.0584 15.8707 12.7276 15.4466 12.2986C14.9867 11.8333 14.6468 11.2963 14.3846 10.7042C14.1218 11.2967 13.7811 11.834 13.3205 12.2993C12.882 12.7424 12.3713 13.0807 11.7953 13.3452ZM4.33203 6.77149C4.12695 6.74219 4 6.63477 4 6.43945C4 6.26367 4.12695 6.14649 4.29297 6.11719C4.3318 6.10982 4.37011 6.10256 4.40789 6.0954C4.41501 6.09405 4.42212 6.0927 4.4292 6.09136C4.43363 6.09052 4.43805 6.08968 4.44246 6.08885C4.79461 6.02208 5.10061 5.96385 5.36733 5.90618C5.75906 5.82148 6.06604 5.738 6.30995 5.63051C6.5973 5.50388 6.79712 5.34393 6.94489 5.10941C7.09934 4.86429 7.19692 4.53769 7.27812 4.08252C7.32794 3.80332 7.37159 3.47574 7.41843 3.08892C7.41909 3.0835 7.41974 3.07807 7.4204 3.07262C7.42284 3.05248 7.42528 3.03218 7.42773 3.01172C7.45703 2.81641 7.58398 2.68945 7.75977 2.68945C7.94531 2.68945 8.07227 2.81641 8.0918 3.00195C8.09575 3.03255 8.09967 3.0628 8.10356 3.09272C8.10447 3.09967 8.10537 3.1066 8.10627 3.11352C8.15486 3.48646 8.19918 3.80655 8.24787 4.08246C8.32892 4.54179 8.42208 4.87867 8.56722 5.13312C8.71038 5.38412 8.90413 5.5549 9.18672 5.68388C9.4285 5.79422 9.73531 5.87395 10.1311 5.94714C10.4072 5.99818 10.7266 6.04604 11.0974 6.09887C11.101 6.09938 11.1045 6.09989 11.1081 6.1004C11.147 6.10594 11.1865 6.11153 11.2266 6.11719C11.3926 6.13672 11.5195 6.26367 11.5195 6.43945C11.5195 6.625 11.3926 6.74219 11.2266 6.77149L11.1735 6.78167C11.1649 6.78333 11.1564 6.78497 11.1478 6.78661C11.1424 6.78766 11.1369 6.7887 11.1315 6.78974C10.7569 6.86167 10.4343 6.92389 10.1556 6.98538C9.75322 7.07412 9.44213 7.16135 9.19744 7.27411C8.92127 7.40139 8.72969 7.56118 8.58698 7.79238C8.43621 8.03663 8.33999 8.36057 8.25619 8.81005C8.20545 9.08223 8.15926 9.40044 8.10828 9.77487C8.10733 9.78179 8.10639 9.78873 8.10544 9.79569C8.10094 9.82886 8.09639 9.86246 8.0918 9.89651C8.07227 10.0723 7.94531 10.1992 7.75977 10.1992C7.58398 10.1992 7.45703 10.0723 7.42773 9.87691C7.42552 9.85848 7.42332 9.84018 7.42113 9.82201C7.42048 9.8166 7.41983 9.81121 7.41918 9.80582C7.37235 9.41813 7.32921 9.08801 7.28033 8.8054C7.20246 8.35524 7.11005 8.02564 6.96501 7.77592C6.81666 7.5205 6.61327 7.34867 6.31408 7.2169C6.07262 7.11056 5.76877 7.03031 5.38113 6.95329C5.1056 6.89854 4.78773 6.84542 4.41984 6.78572C4.4168 6.78522 4.41375 6.78473 4.41069 6.78423C4.38472 6.78002 4.3585 6.77577 4.33203 6.77149Z"
        fill="currentColor"
      />
    </>
  ),
});

export const AssistanceApprovedIcon: CreateIconType = createIcon({
  displayName: 'AssistanceApprovedIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M7.00012 7.43945C7.00012 7.63477 7.12708 7.74219 7.33215 7.77149L7.41996 7.78572C7.78785 7.84542 8.10572 7.89854 8.38125 7.95329C8.7689 8.03031 9.07274 8.11056 9.3142 8.2169C9.61339 8.34867 9.81679 8.5205 9.96514 8.77592C10.1102 9.02564 10.2026 9.35524 10.2804 9.8054C10.3293 10.088 10.3725 10.4181 10.4193 10.8058L10.4279 10.8769C10.4572 11.0723 10.5841 11.1992 10.7599 11.1992C10.9454 11.1992 11.0724 11.0723 11.0919 10.8965L11.1084 10.7749C11.1594 10.4004 11.2056 10.0822 11.2563 9.81005C11.3401 9.36057 11.4363 9.03663 11.5871 8.79238C11.7298 8.56118 11.9214 8.40139 12.1976 8.27411C12.4423 8.16135 12.7533 8.07412 13.1557 7.98538C13.4344 7.92389 13.757 7.86167 14.1316 7.78974L14.2267 7.77149C14.3927 7.74219 14.5197 7.625 14.5197 7.43945C14.5197 7.26367 14.3927 7.13672 14.2267 7.11719L14.0975 7.09887C13.7267 7.04604 13.4073 6.99818 13.1312 6.94714C12.7354 6.87395 12.4286 6.79422 12.1868 6.68388C11.9042 6.5549 11.7105 6.38412 11.5673 6.13312C11.4222 5.87867 11.329 5.54179 11.248 5.08246C11.1993 4.80655 11.155 4.48646 11.1064 4.11352L11.0919 4.00195C11.0724 3.81641 10.9454 3.68945 10.7599 3.68945C10.5841 3.68945 10.4572 3.81641 10.4279 4.01172L10.4186 4.08892C10.3717 4.47574 10.3281 4.80332 10.2782 5.08252C10.197 5.53769 10.0995 5.86429 9.94501 6.10941C9.79724 6.34393 9.59742 6.50388 9.31007 6.63051C9.06616 6.738 8.75919 6.82148 8.36745 6.90618C8.10074 6.96385 7.79473 7.02208 7.44258 7.08885L7.29309 7.11719C7.12707 7.14649 7.00012 7.26367 7.00012 7.43945Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6408 8.70706L10.9337 19.4142L4.72656 13.2071L6.14078 11.7928L10.9337 16.5857L20.2266 7.29285L21.6408 8.70706Z"
        fill="currentColor"
      />
    </>
  ),
});

/**
 * @deprecated use AssistanceAvailableIcon from '@frontend/legacy-components' instead.
 */
export const SuggestionsAvailableIcon: CreateIconType = createIcon({
  displayName: 'SuggestionsAvailableIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M14.3809 21C14.6348 21 14.8203 20.8144 14.8691 20.5508C15.5625 15.209 16.3145 14.3887 21.6074 13.8027C21.8809 13.7734 22.0664 13.5781 22.0664 13.3144C22.0664 13.0605 21.8809 12.8652 21.6074 12.8359C16.3145 12.25 15.5625 11.4297 14.8691 6.07813C14.8203 5.81445 14.6348 5.63867 14.3809 5.63867C14.127 5.63867 13.9414 5.81445 13.9023 6.07813C13.209 11.4297 12.4473 12.25 7.16406 12.8359C6.88086 12.8652 6.69531 13.0605 6.69531 13.3144C6.69531 13.5781 6.88086 13.7734 7.16406 13.8027C12.4375 14.4961 13.1699 15.209 13.9023 20.5508C13.9414 20.8144 14.127 21 14.3809 21ZM7.75977 10.1992C7.94531 10.1992 8.07227 10.0723 8.0918 9.89651C8.44336 7.28906 8.53125 7.28906 11.2266 6.77149C11.3926 6.74219 11.5195 6.625 11.5195 6.43945C11.5195 6.26367 11.3926 6.13672 11.2266 6.11719C8.53125 5.73633 8.43359 5.64844 8.0918 3.00195C8.07227 2.81641 7.94531 2.68945 7.75977 2.68945C7.58398 2.68945 7.45703 2.81641 7.42773 3.01172C7.11523 5.61914 6.96875 5.60938 4.29297 6.11719C4.12695 6.14649 4 6.26367 4 6.43945C4 6.63477 4.12695 6.74219 4.33203 6.77149C6.98828 7.20117 7.11523 7.26953 7.42773 9.87691C7.45703 10.0723 7.58398 10.1992 7.75977 10.1992Z"
        fill="currentColor"
      />
    </>
  ),
});

/**
 * @deprecated use AssistanceRejectedIcon from '@frontend/legacy-components' instead.
 */
export const SuggestionsRejectedIcon: CreateIconType = createIcon({
  displayName: 'SuggestionsRejectedIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M14.8691 6.07813C14.8778 6.14495 14.8864 6.21106 14.8951 6.27647L13.7014 7.47018C13.7714 7.04379 13.8372 6.58097 13.9023 6.07813C13.9414 5.81445 14.127 5.63867 14.3809 5.63867C14.6348 5.63867 14.8203 5.81445 14.8691 6.07813Z"
        fill="currentColor"
      />
      <path
        d="M7.16406 12.8359C7.64817 12.7822 8.09432 12.7266 8.50593 12.6656L7.34484 13.8267L7.16406 13.8027C6.88086 13.7734 6.69531 13.5781 6.69531 13.3144C6.69531 13.0605 6.88086 12.8652 7.16406 12.8359Z"
        fill="currentColor"
      />
      <path
        d="M13.9023 20.5508C13.4813 17.48 13.0603 15.9389 11.7766 15.0519L16.0983 10.7301C16.9864 12.075 18.5288 12.4951 21.6074 12.8359C21.8809 12.8652 22.0664 13.0605 22.0664 13.3144C22.0664 13.5781 21.8809 13.7734 21.6074 13.8027C16.3145 14.3887 15.5625 15.209 14.8691 20.5508C14.8203 20.8144 14.6348 21 14.3809 21C14.127 21 13.9414 20.8144 13.9023 20.5508Z"
        fill="currentColor"
      />
      <path
        d="M7.75977 10.1992C7.94531 10.1992 8.07227 10.0723 8.0918 9.89651C8.44104 7.30627 8.53008 7.28918 11.1735 6.78167L11.2266 6.77149C11.3926 6.74219 11.5195 6.625 11.5195 6.43945C11.5195 6.26367 11.3926 6.13672 11.2266 6.11719C8.53125 5.73633 8.43359 5.64844 8.0918 3.00195C8.07227 2.81641 7.94531 2.68945 7.75977 2.68945C7.58398 2.68945 7.45703 2.81641 7.42773 3.01172C7.11977 5.5813 6.97304 5.60912 4.40789 6.0954L4.29297 6.11719C4.12695 6.14649 4 6.26367 4 6.43945C4 6.63477 4.12695 6.74219 4.33203 6.77149C6.98828 7.20117 7.11523 7.26953 7.42773 9.87691C7.45703 10.0723 7.58398 10.1992 7.75977 10.1992Z"
        fill="currentColor"
      />
      <path
        d="M19.5303 5.53033C19.8232 5.23744 19.8232 4.76256 19.5303 4.46967C19.2374 4.17678 18.7626 4.17678 18.4697 4.46967L4.46967 18.4697C4.17678 18.7626 4.17678 19.2374 4.46967 19.5303C4.76256 19.8232 5.23744 19.8232 5.53033 19.5303L19.5303 5.53033Z"
        fill="currentColor"
      />
    </>
  ),
});

export const FolderMoveIcon: CreateIconType = createIcon({
  displayName: 'FolderMoveIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M10.1271 6.26296L12.2984 8H18.8C19.3931 8 19.7176 8.00156 19.9507 8.02061L19.9771 8.0229L19.9794 8.04927C19.9984 8.28244 20 8.60695 20 9.2V13.4995C20.439 14.0831 20.5889 14.815 20.4498 15.5H21C21.3556 15.5 21.6938 15.5742 22 15.708V9.2C22 8.0799 22 7.51984 21.782 7.09202C21.5903 6.71569 21.2843 6.40973 20.908 6.21799C20.4802 6 19.9201 6 18.8 6H13L11.3765 4.70122C11.0517 4.44132 10.8892 4.31138 10.7083 4.21897C10.5479 4.13698 10.377 4.07706 10.2005 4.04084C10.0016 4 9.79354 4 9.3775 4H5.2C4.0799 4 3.51984 4 3.09202 4.21799C2.71569 4.40973 2.40973 4.71569 2.21799 5.09202C2 5.51984 2 6.0799 2 7.2V16.8C2 17.9201 2 18.4802 2.21799 18.908C2.40973 19.2843 2.71569 19.5903 3.09202 19.782C3.51984 20 4.0799 20 5.2 20H13.4645L12.5251 19.0607C12.2322 18.7678 12.0858 18.3839 12.0858 18H5.2C4.60695 18 4.28244 17.9984 4.04927 17.9794L4.0229 17.9771L4.02061 17.9507C4.00156 17.7176 4 17.3931 4 16.8V7.2C4 6.60695 4.00156 6.28244 4.02061 6.04927L4.0229 6.0229L4.04927 6.02061C4.28244 6.00156 4.60695 6 5.2 6H9.3775C9.60052 6 9.71096 6.00036 9.79126 6.00354L9.79711 6.00378L9.80183 6.00724C9.86652 6.05492 9.95299 6.12364 10.1271 6.26296Z"
        fill="currentColor"
      />
      <path
        d="M18.7071 14.2929C18.3166 13.9024 17.6834 13.9024 17.2929 14.2929L13.5858 18L17.2929 21.7071C17.6834 22.0976 18.3166 22.0976 18.7071 21.7071C19.0976 21.3166 19.0976 20.6834 18.7071 20.2929L17.4142 19H21C21.5523 19 22 18.5523 22 18C22 17.4477 21.5523 17 21 17H17.4142L18.7071 15.7071C19.0976 15.3166 19.0976 14.6834 18.7071 14.2929Z"
        fill="currentColor"
      />
    </>
  ),
});

export const SwapVerticalIcon: CreateIconType = createIcon({
  displayName: 'SwapVerticalIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M19.6995 8.22149C20.0942 8.6078 20.101 9.24092 19.7147 9.63562C19.3284 10.0303 18.6952 10.0371 18.3005 9.65083L17 8.37796L17 16.5C17 17.0523 16.5523 17.5 16 17.5C15.4477 17.5 15 17.0523 15 16.5L15 8.37797L13.6995 9.65083C13.3048 10.0371 12.6716 10.0303 12.2853 9.63562C11.899 9.24092 11.9058 8.6078 12.3005 8.22149L16 4.60074L19.6995 8.22149Z"
        fill="currentColor"
      />
      <path
        d="M4.30054 16.7785C3.90584 16.3922 3.89903 15.7591 4.28533 15.3644C4.67163 14.9697 5.30476 14.9628 5.69946 15.3491L7.00001 16.622L7.00002 8.49999C7.00002 7.9477 7.44774 7.49999 8.00002 7.49999C8.55231 7.49999 9.00002 7.94771 9.00002 8.49999L9.00001 16.622L10.3005 15.3491C10.6952 14.9628 11.3284 14.9697 11.7147 15.3644C12.101 15.7591 12.0942 16.3922 11.6995 16.7785L8 20.3992L4.30054 16.7785Z"
        fill="currentColor"
      />
    </>
  ),
});

export const ArrowUpIcon: CreateIconType = createIcon({
  displayName: 'ArrowUpIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M15 9.93617L12 7M12 7L9 9.93617M12 7L12 17.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  ),
});

export const ColumnsIcon: CreateIconType = createIcon({
  displayName: 'ColumnsIcon',
  viewBox: '0 0 20 20',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 4.1C2 3.21634 2.71634 2.5 3.6 2.5H16.4C17.2837 2.5 18 3.21634 18 4.1V15.9C18 16.7837 17.2837 17.5 16.4 17.5H3.6C2.71634 17.5 2 16.7837 2 15.9V4.1ZM4 4.5H6.66667V15.5H4V4.5ZM11.3333 4.5H8.66666V15.5H11.3333V4.5ZM13.3333 4.5H16V15.5H13.3333V4.5Z"
      fill="currentColor"
    />
  ),
});

export const TableListIcon: CreateIconType = createIcon({
  displayName: 'TableListIcon',
  viewBox: '0 0 20 20',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.16667 2.5C3.24619 2.5 2.5 3.24619 2.5 4.16667V15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5H15.8333C16.7538 17.5 17.5 16.7538 17.5 15.8333V4.16667C17.5 3.24619 16.7538 2.5 15.8333 2.5H4.16667ZM4.16667 4.16667H7.5V7.08333H4.16667V4.16667ZM4.16667 8.54167H7.5V11.4583H4.16667V8.54167ZM7.5 12.9167H4.16667V15.8333H7.5V12.9167ZM9.16667 4.16667H15.8333V7.08333H9.16667V4.16667ZM15.8333 8.54167H9.16667V11.4583H15.8333V8.54167ZM9.16667 12.9167H15.8333V15.8333H9.16667V12.9167Z"
      fill="currentColor"
    />
  ),
});

export const CreateFileIcon: CreateIconType = createIcon({
  displayName: 'CreateFileIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.59999 3.20003H14.25V6.50002C14.25 7.10754 14.7537 7.60002 15.375 7.60002H18.75V9.0397C19.5477 9.12467 20.3053 9.34362 21 9.67363L21 6.85806C21 6.73955 21 6.63409 20.9993 6.53898C21.0005 6.5058 21.0002 6.47265 20.9983 6.43962C20.9944 6.15998 20.9813 5.97496 20.9378 5.79772C20.8827 5.57324 20.7918 5.35864 20.6684 5.1618C20.5293 4.93978 20.3347 4.74954 19.9456 4.36904L17.5544 2.03102C17.1652 1.65052 16.9707 1.46028 16.7436 1.32422C16.5423 1.2036 16.3228 1.11471 16.0932 1.06082C15.912 1.01827 15.7228 1.0055 15.4367 1.00167C15.403 0.999849 15.3691 0.999513 15.3351 1.00068C15.238 1.00003 15.1304 1.00003 15.0094 1.00003L6.59999 1.00003C5.33988 1.00003 4.70982 1.00003 4.22852 1.23982C3.80516 1.45074 3.46095 1.7873 3.24523 2.20125C3 2.67186 3 3.28791 3 4.52003V19.48C3 20.7121 3 21.3282 3.24523 21.7988C3.46095 22.2127 3.80516 22.5493 4.22852 22.7602C4.70982 23 5.33987 23 6.59996 23H11.101C10.4635 22.3753 9.9449 21.6295 9.58246 20.8L6.56288 20.8C5.91919 20.7999 5.56283 20.7979 5.30542 20.7773L5.27576 20.7748L5.27318 20.7458C5.25175 20.4893 5.25 20.1324 5.25 19.48V4.52003C5.25 3.86767 5.25175 3.51071 5.27318 3.25422L5.27575 3.22522L5.30542 3.2227C5.56774 3.20174 5.93281 3.20003 6.59999 3.20003ZM16.5 4.75566V5.40003H17.159L16.5 4.75566Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 17C11 13.6863 13.6863 11 17 11C20.3137 11 23 13.6863 23 17C23 20.3137 20.3137 23 17 23C13.6863 23 11 20.3137 11 17ZM17.8472 14.0833C17.8472 13.6231 17.4679 13.25 17 13.25C16.5321 13.25 16.1528 13.6231 16.1528 14.0833L16.1528 16.1667H14.0347C13.5668 16.1667 13.1875 16.5398 13.1875 17C13.1875 17.4602 13.5668 17.8333 14.0347 17.8333H16.1528L16.1528 19.9167C16.1528 20.3769 16.5321 20.75 17 20.75C17.4679 20.75 17.8472 20.3769 17.8472 19.9167L17.8472 17.8333H19.9653C20.4332 17.8333 20.8125 17.4602 20.8125 17C20.8125 16.5398 20.4332 16.1667 19.9653 16.1667H17.8472L17.8472 14.0833Z"
        fill="currentColor"
      />
    </>
  ),
});

export const PageSplitIcon: CreateIconType = createIcon({
  displayName: 'PageSplitIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.75 4C5.75 3.86193 5.86193 3.75 6 3.75H14.6893L18.25 7.31066V10H19.75V6.68934L15.3107 2.25H6C5.0335 2.25 4.25 3.0335 4.25 4V10H5.75V4ZM7.6647 18V15H9.6647C9.6647 15.5523 10.1124 16 10.6647 16C11.217 16 11.6647 15.5523 11.6647 15H16.6647V17.1742C16.6647 16.8823 16.5371 16.6049 16.3155 16.415L15.3155 15.5578C14.941 15.2368 14.3884 15.2368 14.0139 15.5578L11.6998 17.5414C11.3789 17.8164 10.9198 17.86 10.5528 17.6504L10.1914 17.4438C9.8677 17.2589 9.46803 17.2693 9.15446 17.4709L8.12395 18.1333C7.98344 18.2237 7.87021 18.346 7.79134 18.4874C7.71068 18.3432 7.6647 18.177 7.6647 18ZM5.75 20V15H4.25V20C4.25 20.9665 5.0335 21.75 6 21.75H18C18.9665 21.75 19.75 20.9665 19.75 20V15H18.25V20C18.25 20.1381 18.1381 20.25 18 20.25H6C5.86193 20.25 5.75 20.1381 5.75 20ZM15.9147 9.5C15.9147 9.69209 15.8425 9.86731 15.7237 10H7.60568C7.48692 9.86731 7.4147 9.69209 7.4147 9.5C7.4147 9.08579 7.75049 8.75 8.1647 8.75H15.1647C15.5789 8.75 15.9147 9.08579 15.9147 9.5ZM8.1647 5.75C7.75049 5.75 7.4147 6.08579 7.4147 6.5C7.4147 6.91421 7.75049 7.25 8.1647 7.25H12.6647C13.0789 7.25 13.4147 6.91421 13.4147 6.5C13.4147 6.08579 13.0789 5.75 12.6647 5.75H8.1647ZM2.5 11.75C2.08579 11.75 1.75 12.0858 1.75 12.5C1.75 12.9142 2.08579 13.25 2.5 13.25H4.8125C5.22671 13.25 5.5625 12.9142 5.5625 12.5C5.5625 12.0858 5.22671 11.75 4.8125 11.75H2.5ZM9.4375 11.75C9.02329 11.75 8.6875 12.0858 8.6875 12.5C8.6875 12.9142 9.02329 13.25 9.4375 13.25H14.0625C14.4767 13.25 14.8125 12.9142 14.8125 12.5C14.8125 12.0858 14.4767 11.75 14.0625 11.75H9.4375ZM18.6875 11.75C18.2733 11.75 17.9375 12.0858 17.9375 12.5C17.9375 12.9142 18.2733 13.25 18.6875 13.25H21C21.4142 13.25 21.75 12.9142 21.75 12.5C21.75 12.0858 21.4142 11.75 21 11.75H18.6875Z"
        fill="currentColor"
      />
    </>
  ),
});

export const CrossSectionIcon: CreateIconType = createIcon({
  displayName: 'CrossSectionIcon',
  viewBox: '0 0 15 20',
  path: (
    <>
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth={1}
        d="m9.715.613 4.125 1.523c.508.224.678.511.659 1.48v8.66c-.005 1.555-.352 2.088-1.317 2.697l-6.45 4.392c-.176.134-.34.177-.615.09l-3.906-1.436C.897 17.387.5 16.874.5 15.626v-8.05c.008-1.33.289-1.921 1.36-2.655l5.266-3.655C8.224.481 8.785.373 9.716.613Z"
      />
      <path
        fill="currentColor"
        d="m7.126 1.266.285.41.006-.004-.291-.406Zm2.59-.653.173-.469A.5.5 0 0 0 9.841.13l-.125.484Zm4.124 1.524.202-.458a.518.518 0 0 0-.029-.011l-.173.469Zm.37.236-.086.493a.5.5 0 0 0 .44-.846l-.353.353Zm-2.037.79.285.411.006-.004-.291-.407ZM6.907 6.818l.283.413.002-.002-.285-.41Zm-1.36 2.655-.5-.003v.003h.5Zm0 8.05h.5-.5Zm.535 1.925-.16.474a.5.5 0 0 0 .423-.899l-.263.425Zm-.316-.122.195-.46a.589.589 0 0 0-.023-.009l-.172.47ZM2.21 18.02l-.217.45.044.019.173-.47ZM.5 15.626H1 .5Zm0-8.05L0 7.571v.003h.5ZM1.86 4.92l.283.413.002-.002-.285-.411Zm5.266-3.655.29.406c.533-.38.885-.558 1.185-.63.285-.07.568-.053.99.056l.125-.485L9.84.13c-.509-.131-.972-.181-1.475-.06-.488.118-.965.386-1.53.79l.29.407Zm2.59-.653-.173.47 4.124 1.523.173-.47.173-.468L9.89.144l-.173.47Zm4.124 1.524-.202.457a.708.708 0 0 1 .22.132l.353-.353.354-.353a1.678 1.678 0 0 0-.523-.34l-.202.457Zm.37.236.087-.492c-.48-.085-.866-.045-1.265.135-.355.16-.719.432-1.15.74l.29.407.292.407c.48-.343.739-.535.978-.642.194-.087.372-.117.682-.062l.087-.493Zm-2.037.79-.285-.41-5.266 3.655.285.41.285.411 5.266-3.655-.285-.41ZM6.907 6.818l-.282-.412c-.568.388-.983.777-1.243 1.29-.257.51-.33 1.082-.335 1.774l.5.003.5.003c.004-.638.075-1.026.228-1.328.15-.298.41-.572.915-.917l-.283-.413Zm-1.36 2.655h-.5v8.05h1v-8.05h-.5Zm0 8.05h-.5c0 .508.02.971.113 1.355.095.394.283.763.66.996l.262-.426.263-.425c-.073-.045-.153-.134-.213-.38-.063-.259-.085-.618-.085-1.12h-.5Zm.535 1.925.16-.474a4 4 0 0 1-.281-.108l-.195.46-.195.46c.13.056.247.101.352.136l.159-.474Zm-.316-.122.172-.469-3.555-1.307-.172.47-.173.469 3.555 1.307.173-.47ZM2.21 18.02l.217-.45c-.641-.31-.973-.552-1.16-.81C1.091 16.518 1 16.2 1 15.626H0c0 .674.106 1.237.458 1.721.34.47.863.8 1.536 1.123l.217-.45ZM.5 15.626H1v-8.05H0v8.05h.5Zm0-8.05.5.003c.004-.638.075-1.026.228-1.329.15-.298.41-.571.915-.916L1.86 4.92l-.282-.413c-.567.39-.983.779-1.243 1.293C.078 6.308.005 6.881 0 7.572l.5.003ZM1.86 4.92l.285.41 5.266-3.655-.285-.41-.285-.411L1.575 4.51l.285.411Z"
      />
      <path
        fill="currentColor"
        d="M6.602 19.454H6.6c-.106.063-.216.075-.387.033l-.359-.251a1.268 1.268 0 0 1-.2-.443l.948.66Zm1.137-.774-.22.15-1.973-1.375v-.305l2.193 1.53Zm1.136-.774-.22.151-3.109-2.169v-.304l3.33 2.322Zm1.136-.773-.22.15-4.245-2.961v-.305l4.465 3.116Zm1.137-.774-.22.15-5.382-3.754v-.304l5.602 3.908Zm1.137-.773-.222.15-6.517-4.547v-.305l6.739 4.702Zm1.137-.773c-.07.05-.144.1-.222.15l-7.654-5.34v-.15c0-.052.003-.103.004-.153l7.872 5.493Zm.845-.977c-.033.08-.072.155-.113.226L5.72 8.178c.029-.082.061-.16.099-.236l8.447 5.894Zm.23-1.408a7.662 7.662 0 0 1-.012.298L6.48 7.141c.064-.053.132-.108.204-.162l7.812 5.45Zm.002-1.564v.306L7.587 6.347l.22-.152 6.691 4.669Zm0-1.566v.304L8.713 5.565l.22-.151 5.566 3.884Zm0-1.567v.305l-4.66-3.252.22-.152 4.44 3.1Zm0-1.566v.305l-3.535-2.466.22-.153 3.315 2.314Zm0-1.567v.306l-2.41-1.682.083-.058.135-.095 2.191 1.53Zm-.023-1.582c.012.095.018.201.022.32l-1.246-.87c.1-.043.196-.076.296-.097l.928.647Z"
      />
    </>
  ),
});
